<template>
  <div>
    <div class="control-section">
            <div align='center'>
                <ejs-chart style='display:block;width: 100%' :theme='theme2' :chartArea='chartArea2' :width='width2' align='center' id='chart2'
                    :primaryXAxis='primaryXAxis2' :legendSettings='legend2' :zoomSettings='zoomSettings2' :title='title2' 
                    :tooltip='tooltip' :primaryYAxis='primaryYAxis2'>
                    <e-series-collection>
                        <e-series :dataSource='series2' type='Area' xName='x' yName='y' :animation='animation2' fill='url(#gradient-chart)' :border='border'>
                        </e-series>
                    </e-series-collection>
                </ejs-chart>
            </div>  

            <svg style="height: 0">
                <defs>
                    <linearGradient id="gradient-chart" style="opacity: 0.75" class="chart-material" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0"></stop>
                        <stop offset="1"></stop>
                    </linearGradient>
                </defs>
            </svg>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { Browser } from '@syncfusion/ej2-base';
    //import { ChartPlugin, AreaSeries, Zoom, Legend, DateTime, ScrollBar, Tooltip } from "@syncfusion/ej2-vue-charts";
    import { ChartPlugin, AreaSeries, Zoom, Legend, ScrollBar, Tooltip } from "@syncfusion/ej2-vue-charts";
    
    Vue.use(ChartPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");
/*
    function GetZoomingData() {
        let series = [];
        let point1;
        let value = 80;
        for (let i = 1; i < 500; i++) {
            if (Math.random() > .5) {
                value += Math.random();
            } else {
                value -= Math.random();
            }
            point1 = { x: new Date(2017, i + 2, i), y: value.toFixed(1) };
            series.push(point1);
        }
        return { 'series': series };
    }

    let seriesData = GetZoomingData().series; */
    let seriesCorrente = [
        { x: '1' , y: '0' },
        { x: '2' , y: '0' },
        { x: '3' , y: '0' },
        { x: '4' , y: '0' },
        { x: '5' , y: '0' },
        { x: '6' , y: '0' },
        { x: '7' , y: '0' },
        { x: '8' , y: '0' },
        { x: '9' , y: '0' },
        { x: '10' , y: '0' },
        { x: '11' , y: '9' },
        { x: '12' , y: '9' },
        { x: '13' , y: '8' },
        { x: '14' , y: '8' },
        { x: '15' , y: '8' },
        { x: '16' , y: '7' },
        { x: '17' , y: '7' },
        { x: '18' , y: '7' },
        { x: '19' , y: '6' },
        { x: '20' , y: '6' },
        { x: '21' , y: '6' },
        { x: '22' , y: '6' },
        { x: '23' , y: '5' },
        { x: '24' , y: '5' },
        { x: '25' , y: '5' },
        { x: '26' , y: '5' },
        { x: '27' , y: '5' },
        { x: '28' , y: '5' },
        { x: '29' , y: '4' },
        { x: '30' , y: '4' },
        { x: '31' , y: '4' },
        { x: '32' , y: '4' },
        { x: '33' , y: '4' },
        { x: '34' , y: '4' },
        { x: '35' , y: '3' },
        { x: '36' , y: '3' },
        { x: '37' , y: '3' },
        { x: '38' , y: '3' },
        { x: '39' , y: '3' },
        { x: '40' , y: '3' },
        { x: '41' , y: '3' },
        { x: '42' , y: '3' },
        { x: '43' , y: '2' },
        { x: '44' , y: '2' },
        { x: '45' , y: '2' },
        { x: '46' , y: '2' },
        { x: '47' , y: '2' },
        { x: '48' , y: '2' },
        { x: '49' , y: '2' },
        { x: '50' , y: '2' },
        { x: '51' , y: '2' },
        { x: '52' , y: '2' },
        { x: '53' , y: '2' },
        { x: '54' , y: '2' },
        { x: '55' , y: '2' },
        { x: '56' , y: '1' },
        { x: '57' , y: '1' },
        { x: '58' , y: '1' },
        { x: '59' , y: '1' },
        { x: '60' , y: '1' },
        { x: '61' , y: '1' },
        { x: '62' , y: '1' },
        { x: '63' , y: '1' },
        { x: '64' , y: '1' },
        { x: '65' , y: '1' },
        { x: '66' , y: '1' },
        { x: '67' , y: '1' },
        { x: '68' , y: '1' },
        { x: '69' , y: '1' },
        { x: '70' , y: '1' },
        { x: '71' , y: '1' },
        { x: '72' , y: '1' },
        { x: '73' , y: '1' },
        { x: '74' , y: '1' },
        { x: '75' , y: '1' },
        { x: '76' , y: '1' },
        { x: '77' , y: '1' },
        { x: '78' , y: '1' },
        { x: '79' , y: '1' },
        { x: '80' , y: '1' },
        { x: '81' , y: '1' },
        { x: '82' , y: '1' },
        { x: '83' , y: '1' },
        { x: '84' , y: '1' },
        { x: '85' , y: '1' },
        { x: '86' , y: '1' },
        { x: '87' , y: '0' },
        { x: '88' , y: '0' },
        { x: '89' , y: '0' },
        { x: '90' , y: '0' },
        { x: '91' , y: '0' },
        { x: '92' , y: '0' },
        { x: '93' , y: '0' },
        { x: '94' , y: '0' },
        { x: '95' , y: '0' },
        { x: '96' , y: '0' },
        { x: '97' , y: '0' },
        { x: '98' , y: '0' },
        { x: '99' , y: '0' },
        { x: '100' , y: '6.08' },
        { x: '101' , y: '6.08' },
        { x: '102' , y: '6.08' },
        { x: '103' , y: '6.08' },
        { x: '104' , y: '6.08' },
        { x: '105' , y: '6.08' },
        { x: '106' , y: '6.08' },
        { x: '107' , y: '6.08' },
        { x: '108' , y: '6.08' },
        { x: '109' , y: '6.08' },
        { x: '110' , y: '6.08' },
        { x: '111' , y: '6.08' },
        { x: '112' , y: '6.08' },
        { x: '113' , y: '6.08' },
        { x: '114' , y: '6.08' },
        { x: '115' , y: '6.08' },
        { x: '116' , y: '6.08' },
        { x: '117' , y: '6.08' },
        { x: '118' , y: '6.08' },
        { x: '119' , y: '6.08' },
        { x: '120' , y: '6.08' },
        { x: '121' , y: '6.08' },
        { x: '122' , y: '6.08' },
        { x: '123' , y: '6.08' },
        { x: '124' , y: '6.08' },
        { x: '125' , y: '6.08' },
        { x: '126' , y: '6.08' },
        { x: '127' , y: '6.08' },
        { x: '128' , y: '6.08' },
        { x: '129' , y: '6.08' },
        { x: '130' , y: '6.08' },
        { x: '131' , y: '6.08' },
        { x: '132' , y: '6.08' },
        { x: '133' , y: '6.08' },
        { x: '134' , y: '6.08' },
        { x: '135' , y: '6.08' },
        { x: '136' , y: '6.08' },
        { x: '137' , y: '6.08' },
        { x: '138' , y: '6.08' },
        { x: '139' , y: '6.08' },
        { x: '140' , y: '6.08' },
        { x: '141' , y: '6.08' },
        { x: '142' , y: '6.08' },
        { x: '143' , y: '6.08' },
        { x: '144' , y: '6.08' },
        { x: '145' , y: '6.08' },
        { x: '146' , y: '6.08' },
        { x: '147' , y: '6.08' },
        { x: '148' , y: '6.08' },
        { x: '149' , y: '6.08' },
        { x: '150' , y: '6.08' },
        { x: '151' , y: '6.08' },
        { x: '152' , y: '6.08' },
        { x: '153' , y: '6.08' },
        { x: '154' , y: '6.08' },
        { x: '155' , y: '6.08' },
        { x: '156' , y: '6.08' },
        { x: '157' , y: '6.08' },
        { x: '158' , y: '6.08' },
        { x: '159' , y: '6.08' },
        { x: '160' , y: '6.08' },
        { x: '161' , y: '6.08' },
        { x: '162' , y: '6.08' },
        { x: '163' , y: '6.08' },
        { x: '164' , y: '6.08' },
        { x: '165' , y: '6.08' },
        { x: '166' , y: '6.08' },
        { x: '167' , y: '6.08' },
        { x: '168' , y: '6.08' },
        { x: '169' , y: '6.08' },
        { x: '170' , y: '6.08' },
        { x: '171' , y: '6.08' },
        { x: '172' , y: '6.08' },
        { x: '173' , y: '6.08' },
        { x: '174' , y: '6.08' },
        { x: '175' , y: '6.08' },
        { x: '176' , y: '6.08' },
        { x: '177' , y: '6.08' },
        { x: '178' , y: '6.08' },
        { x: '179' , y: '6.08' },
        { x: '180' , y: '6.08' },
        { x: '181' , y: '6.08' },
        { x: '182' , y: '6.08' },
        { x: '183' , y: '6.08' },
        { x: '184' , y: '6.08' },
        { x: '185' , y: '6.08' },
        { x: '186' , y: '6.08' },
        { x: '187' , y: '6.08' },
        { x: '188' , y: '6.08' },
        { x: '189' , y: '6.08' },
        { x: '190' , y: '6.08' },
        { x: '191' , y: '6.08' },
        { x: '192' , y: '6.08' },
        { x: '193' , y: '6.08' },
        { x: '194' , y: '6.08' },
        { x: '195' , y: '6.08' },
        { x: '196' , y: '6.08' },
        { x: '197' , y: '6.08' },
        { x: '198' , y: '6.08' },
        { x: '199' , y: '6.08' },
        { x: '200' , y: '6.08' },
        { x: '201' , y: '6.08' },
        { x: '202' , y: '6.08' },
        { x: '203' , y: '6.08' },
        { x: '204' , y: '6.08' },
        { x: '205' , y: '6.08' },
        { x: '206' , y: '6.08' },
        { x: '207' , y: '6.08' },
        { x: '208' , y: '6.08' },
        { x: '209' , y: '6.08' },
        { x: '210' , y: '6.08' },
        { x: '211' , y: '6.08' },
        { x: '212' , y: '6.08' },
        { x: '213' , y: '6.08' },
        { x: '214' , y: '6.08' },
        { x: '215' , y: '6.08' },
        { x: '216' , y: '6.08' },
        { x: '217' , y: '6.08' },
        { x: '218' , y: '6.08' },
        { x: '219' , y: '6.08' },
        { x: '220' , y: '6.08' },
        { x: '221' , y: '6.08' },
        { x: '222' , y: '6.08' },
        { x: '223' , y: '6.08' },
        { x: '224' , y: '6.08' },
        { x: '225' , y: '6.08' },
        { x: '226' , y: '6.08' },
        { x: '227' , y: '6.08' },
        { x: '228' , y: '6.08' },
        { x: '229' , y: '6.08' },
        { x: '230' , y: '6.08' },
        { x: '231' , y: '6.08' },
        { x: '232' , y: '6.08' },
        { x: '233' , y: '6.08' },
        { x: '234' , y: '6.08' },
        { x: '235' , y: '6.08' },
        { x: '236' , y: '6.08' },
        { x: '237' , y: '6.08' },
        { x: '238' , y: '6.08' },
        { x: '239' , y: '6.08' },
        { x: '240' , y: '6.08' },
        { x: '241' , y: '6.08' },
        { x: '242' , y: '6.08' },
        { x: '243' , y: '6.08' },
        { x: '244' , y: '6.08' },
        { x: '245' , y: '6.08' },
        { x: '246' , y: '6.08' },
        { x: '247' , y: '6.08' },
        { x: '248' , y: '6.08' },
        { x: '249' , y: '6.08' },
        { x: '250' , y: '6.08' },
        { x: '251' , y: '6.08' },
        { x: '252' , y: '6.08' },
        { x: '253' , y: '6.08' },
        { x: '254' , y: '6.08' },
        { x: '255' , y: '6.08' },
        { x: '256' , y: '6.08' },
        { x: '257' , y: '6.08' },
        { x: '258' , y: '6.08' },
        { x: '259' , y: '6.08' },
        { x: '260' , y: '6.08' },
        { x: '261' , y: '6.08' },
        { x: '262' , y: '6.08' },
        { x: '263' , y: '6.08' },
        { x: '264' , y: '6.08' },
        { x: '265' , y: '6.08' },
        { x: '266' , y: '6.08' },
        { x: '267' , y: '6.08' },
        { x: '268' , y: '6.08' },
        { x: '269' , y: '6.08' },
        { x: '270' , y: '6.08' },
        { x: '271' , y: '6.08' },
        { x: '272' , y: '6.08' },
        { x: '273' , y: '6.08' },
        { x: '274' , y: '6.08' },
        { x: '275' , y: '6.08' },
        { x: '276' , y: '6.08' },
        { x: '277' , y: '6.08' },
        { x: '278' , y: '6.08' },
        { x: '279' , y: '6.08' },
        { x: '280' , y: '6.08' },
        { x: '281' , y: '6.08' },
        { x: '282' , y: '6.08' },
        { x: '283' , y: '6.08' },
        { x: '284' , y: '6.08' },
        { x: '285' , y: '6.08' },
        { x: '286' , y: '6.08' },
        { x: '287' , y: '6.08' },
        { x: '288' , y: '6.08' },
        { x: '289' , y: '6.08' },
        { x: '290' , y: '6.08' },
        { x: '291' , y: '6.08' },
        { x: '292' , y: '6.08' },
        { x: '293' , y: '6.08' },
        { x: '294' , y: '6.08' },
        { x: '295' , y: '6.08' },
        { x: '296' , y: '6.08' },
        { x: '297' , y: '6.08' },
        { x: '298' , y: '6.08' },
        { x: '299' , y: '6.08' },
        { x: '300' , y: '6.08' },
        { x: '301' , y: '6.08' },
        { x: '302' , y: '6.08' },
        { x: '303' , y: '6.08' },
        { x: '304' , y: '6.08' },
        { x: '305' , y: '6.08' },
        { x: '306' , y: '6.08' },
        { x: '307' , y: '6.08' },
        { x: '308' , y: '6.08' },
        { x: '309' , y: '6.08' },
        { x: '310' , y: '6.08' },
        { x: '311' , y: '6.08' },
        { x: '312' , y: '6.08' },
        { x: '313' , y: '6.08' },
        { x: '314' , y: '6.08' },
        { x: '315' , y: '6.08' },
        { x: '316' , y: '6.08' },
        { x: '317' , y: '6.08' },
        { x: '318' , y: '6.08' },
        { x: '319' , y: '6.08' },
        { x: '320' , y: '6.08' },
        { x: '321' , y: '6.08' },
        { x: '322' , y: '6.08' },
        { x: '323' , y: '6.08' },
        { x: '324' , y: '6.08' },
        { x: '325' , y: '6.08' },
        { x: '326' , y: '6.08' },
        { x: '327' , y: '6.08' },
        { x: '328' , y: '6.08' },
        { x: '329' , y: '6.08' },
        { x: '330' , y: '6.08' },
        { x: '331' , y: '6.08' },
        { x: '332' , y: '6.08' },
        { x: '333' , y: '6.08' },
        { x: '334' , y: '6.08' },
        { x: '335' , y: '6.08' },
        { x: '336' , y: '6.08' },
        { x: '337' , y: '6.08' },
        { x: '338' , y: '6.08' },
        { x: '339' , y: '6.08' },
        { x: '340' , y: '6.08' },
        { x: '341' , y: '6.08' },
        { x: '342' , y: '6.08' },
        { x: '343' , y: '6.08' },
        { x: '344' , y: '6.08' },
        { x: '345' , y: '6.08' },
        { x: '346' , y: '6.08' },
        { x: '347' , y: '6.20' },
        { x: '348' , y: '6.20' },
        { x: '349' , y: '6.20' },
        { x: '350' , y: '6.20' },
        { x: '351' , y: '6.20' },
        { x: '352' , y: '6.20' },
        { x: '353' , y: '6.20' },
        { x: '354' , y: '6.20' },
        { x: '355' , y: '6.20' },
        { x: '356' , y: '6.20' },
        { x: '357' , y: '6.20' },
        { x: '358' , y: '6.20' },
        { x: '359' , y: '6.20' },
        { x: '360' , y: '6.20' },
        { x: '361' , y: '6.20' },
        { x: '362' , y: '6.20' },
        { x: '363' , y: '6.20' },
        { x: '364' , y: '6.20' },
        { x: '365' , y: '6.20' },
        { x: '366' , y: '6.20' },
        { x: '367' , y: '6.20' },
        { x: '368' , y: '6.20' },
        { x: '369' , y: '6.20' },
        { x: '370' , y: '6.20' },
        { x: '371' , y: '6.20' },
        { x: '372' , y: '6.20' },
        { x: '373' , y: '6.20' },
        { x: '374' , y: '6.20' },
        { x: '375' , y: '6.20' },
        { x: '376' , y: '6.20' },
        { x: '377' , y: '6.20' },
        { x: '378' , y: '6.20' },
        { x: '379' , y: '6.20' },
        { x: '380' , y: '6.20' },
        { x: '381' , y: '6.20' },
        { x: '382' , y: '6.20' },
        { x: '383' , y: '6.20' },
        { x: '384' , y: '6.20' },
        { x: '385' , y: '6.20' },
        { x: '386' , y: '6.20' },
        { x: '387' , y: '6.20' },
        { x: '388' , y: '6.20' },
        { x: '389' , y: '6.20' },
        { x: '390' , y: '6.20' },
        { x: '391' , y: '6.20' },
        { x: '392' , y: '6.20' },
        { x: '393' , y: '6.20' },
        { x: '394' , y: '6.20' },
        { x: '395' , y: '6.20' },
        { x: '396' , y: '6.20' },
        { x: '397' , y: '6.20' },
        { x: '398' , y: '6.20' },
        { x: '399' , y: '6.20' },
        { x: '400' , y: '6.20' },
        { x: '401' , y: '6.20' },
        { x: '402' , y: '6.20' },
        { x: '403' , y: '6.20' },
        { x: '404' , y: '6.20' },
        { x: '405' , y: '6.20' },
        { x: '406' , y: '6.20' },
        { x: '407' , y: '6.20' },
        { x: '408' , y: '6.20' },
        { x: '409' , y: '6.20' },
        { x: '410' , y: '6.20' },
        { x: '411' , y: '6.20' },
        { x: '412' , y: '6.20' },
        { x: '413' , y: '6.20' },
        { x: '414' , y: '6.20' },
        { x: '415' , y: '6.20' },
        { x: '416' , y: '6.20' },
        { x: '417' , y: '6.20' },
        { x: '418' , y: '6.20' },
        { x: '419' , y: '6.20' },
        { x: '420' , y: '6.20' },
        { x: '421' , y: '6.20' },
        { x: '422' , y: '6.20' },
        { x: '423' , y: '6.20' },
        { x: '424' , y: '6.20' },
        { x: '425' , y: '6.20' },
        { x: '426' , y: '6.20' },
        { x: '427' , y: '6.20' },
        { x: '428' , y: '6.20' },
        { x: '429' , y: '6.20' },
        { x: '430' , y: '6.20' },
        { x: '431' , y: '6.20' },
        { x: '432' , y: '6.20' },
        { x: '433' , y: '6.20' },
        { x: '434' , y: '6.20' },
        { x: '435' , y: '6.20' },
        { x: '436' , y: '6.20' },
        { x: '437' , y: '6.20' },
        { x: '438' , y: '6.20' },
        { x: '439' , y: '6.20' },
        { x: '440' , y: '6.20' },
        { x: '441' , y: '6.20' },
        { x: '442' , y: '6.20' },
        { x: '443' , y: '6.20' },
        { x: '444' , y: '6.20' },
        { x: '445' , y: '6.20' },
        { x: '446' , y: '6.20' },
        { x: '447' , y: '6.20' },
        { x: '448' , y: '6.20' },
        { x: '449' , y: '6.20' },
        { x: '450' , y: '6.20' },
        { x: '451' , y: '6.20' },
        { x: '452' , y: '6.20' },
        { x: '453' , y: '6.20' },
        { x: '454' , y: '5.93' },
        { x: '455' , y: '5.93' },
        { x: '456' , y: '5.93' },
        { x: '457' , y: '5.93' },
        { x: '458' , y: '5.93' },
        { x: '459' , y: '5.93' },
        { x: '460' , y: '5.93' },
        { x: '461' , y: '5.93' },
        { x: '462' , y: '5.93' },
        { x: '463' , y: '5.93' },
        { x: '464' , y: '5.93' },
        { x: '465' , y: '5.93' },
        { x: '466' , y: '5.93' },
        { x: '467' , y: '5.93' },
        { x: '468' , y: '5.93' },
        { x: '469' , y: '5.93' },
        { x: '470' , y: '5.93' },
        { x: '471' , y: '5.93' },
        { x: '472' , y: '5.93' },
        { x: '473' , y: '5.93' },
        { x: '474' , y: '5.93' },
        { x: '475' , y: '5.93' },
        { x: '476' , y: '5.93' },
        { x: '477' , y: '5.93' },
        { x: '478' , y: '5.93' },
        { x: '479' , y: '5.93' },
        { x: '480' , y: '5.93' },
        { x: '481' , y: '5.93' },
        { x: '482' , y: '5.93' },
        { x: '483' , y: '5.93' },
        { x: '484' , y: '5.93' },
        { x: '485' , y: '5.93' },
        { x: '486' , y: '5.93' },
        { x: '487' , y: '5.93' },
        { x: '488' , y: '5.93' },
        { x: '489' , y: '5.93' },
        { x: '490' , y: '5.93' },
        { x: '491' , y: '5.93' },
        { x: '492' , y: '5.93' },
        { x: '493' , y: '5.93' },
        { x: '494' , y: '5.93' },
        { x: '495' , y: '5.93' },
        { x: '496' , y: '5.93' },
        { x: '497' , y: '5.93' },
        { x: '498' , y: '5.93' },
        { x: '499' , y: '5.93' },
        { x: '500' , y: '5.93' },
        { x: '501' , y: '5.93' },
        { x: '502' , y: '5.93' },
        { x: '503' , y: '5.93' },
        { x: '504' , y: '5.93' },
        { x: '505' , y: '5.93' },
        { x: '506' , y: '5.93' },
        { x: '507' , y: '5.93' },
        { x: '508' , y: '5.93' },
        { x: '509' , y: '5.93' },
        { x: '510' , y: '5.93' },
        { x: '511' , y: '5.93' },
        { x: '512' , y: '5.93' },
        { x: '513' , y: '5.93' },
        { x: '514' , y: '5.93' },
        { x: '515' , y: '5.93' },
        { x: '516' , y: '5.93' },
        { x: '517' , y: '5.93' },
        { x: '518' , y: '5.93' },
        { x: '519' , y: '5.93' },
        { x: '520' , y: '5.93' },
        { x: '521' , y: '5.93' },
        { x: '522' , y: '5.93' },
        { x: '523' , y: '5.93' },
        { x: '524' , y: '5.93' },
        { x: '525' , y: '5.93' },
        { x: '526' , y: '5.93' },
        { x: '527' , y: '5.93' },
        { x: '528' , y: '5.93' },
        { x: '529' , y: '5.93' },
        { x: '530' , y: '5.93' },
        { x: '531' , y: '5.93' },
        { x: '532' , y: '5.93' },
        { x: '533' , y: '5.93' },
        { x: '534' , y: '5.93' },
        { x: '535' , y: '5.93' },
        { x: '536' , y: '5.93' },
        { x: '537' , y: '5.93' },
        { x: '538' , y: '5.93' },
        { x: '539' , y: '5.93' },
        { x: '540' , y: '5.93' },
        { x: '541' , y: '5.93' },
        { x: '542' , y: '5.93' },
        { x: '543' , y: '5.93' },
        { x: '544' , y: '5.93' },
        { x: '545' , y: '5.93' },
        { x: '546' , y: '5.93' },
        { x: '547' , y: '5.93' },
        { x: '548' , y: '5.93' },
        { x: '549' , y: '5.93' },
        { x: '550' , y: '5.93' },
        { x: '551' , y: '5.93' },
        { x: '552' , y: '5.93' },
        { x: '553' , y: '5.93' },
        { x: '554' , y: '5.93' },
        { x: '555' , y: '5.93' },
        { x: '556' , y: '5.93' },
        { x: '557' , y: '5.93' },
        { x: '558' , y: '5.93' },
        { x: '559' , y: '5.93' },
        { x: '560' , y: '5.93' },
        { x: '561' , y: '5.93' },
        { x: '562' , y: '5.93' },
        { x: '563' , y: '5.93' },
        { x: '564' , y: '5.93' },
        { x: '565' , y: '5.93' },
        { x: '566' , y: '5.93' },
        { x: '567' , y: '5.93' },
        { x: '568' , y: '5.93' },
        { x: '569' , y: '5.93' },
        { x: '570' , y: '5.93' },
        { x: '571' , y: '5.93' },
        { x: '572' , y: '5.93' },
        { x: '573' , y: '5.93' },
        { x: '574' , y: '5.93' },
        { x: '575' , y: '5.93' },
        { x: '576' , y: '5.93' },
        { x: '577' , y: '5.93' },
        { x: '578' , y: '5.93' },
        { x: '579' , y: '5.93' },
        { x: '580' , y: '5.93' },
        { x: '581' , y: '5.93' },
        { x: '582' , y: '5.93' },
        { x: '583' , y: '5.93' },
        { x: '584' , y: '5.93' },
        { x: '585' , y: '5.93' },
        { x: '586' , y: '5.93' },
        { x: '587' , y: '5.93' },
        { x: '588' , y: '5.93' },
        { x: '589' , y: '5.93' },
        { x: '590' , y: '5.93' },
        { x: '591' , y: '5.93' },
        { x: '592' , y: '5.93' },
        { x: '593' , y: '5.93' },
        { x: '594' , y: '5.93' },
        { x: '595' , y: '5.93' },
        { x: '596' , y: '5.93' },
        { x: '597' , y: '5.93' },
        { x: '598' , y: '5.93' },
        { x: '599' , y: '5.93' },
        { x: '600' , y: '5.93' },
        { x: '601' , y: '5.93' },
        { x: '602' , y: '5.93' },
        { x: '603' , y: '5.93' },
        { x: '604' , y: '5.93' },
        { x: '605' , y: '5.93' },
        { x: '606' , y: '5.93' },
        { x: '607' , y: '5.93' },
        { x: '608' , y: '5.93' },
        { x: '609' , y: '5.93' },
        { x: '610' , y: '5.93' },
        { x: '611' , y: '5.93' },
        { x: '612' , y: '5.93' },
        { x: '613' , y: '5.93' },
        { x: '614' , y: '5.93' },
        { x: '615' , y: '5.93' },
        { x: '616' , y: '5.93' },
        { x: '617' , y: '5.93' },
        { x: '618' , y: '5.93' },
        { x: '619' , y: '5.93' },
        { x: '620' , y: '5.93' },
        { x: '621' , y: '5.93' },
        { x: '622' , y: '5.93' },
        { x: '623' , y: '5.93' },
        { x: '624' , y: '5.93' },
        { x: '625' , y: '5.93' },
        { x: '626' , y: '5.93' },
        { x: '627' , y: '5.93' },
        { x: '628' , y: '5.93' },
        { x: '629' , y: '5.93' },
        { x: '630' , y: '5.93' },
        { x: '631' , y: '5.93' },
        { x: '632' , y: '5.93' },
        { x: '633' , y: '5.93' },
        { x: '634' , y: '5.93' },
        { x: '635' , y: '5.93' },
        { x: '636' , y: '5.93' },
        { x: '637' , y: '5.93' },
        { x: '638' , y: '5.93' },
        { x: '639' , y: '5.93' },
        { x: '640' , y: '5.93' },
        { x: '641' , y: '5.93' },
        { x: '642' , y: '5.93' },
        { x: '643' , y: '5.93' },
        { x: '644' , y: '5.93' },
        { x: '645' , y: '5.93' },
        { x: '646' , y: '5.93' },
        { x: '647' , y: '5.93' },
        { x: '648' , y: '5.93' },
        { x: '649' , y: '5.93' },
        { x: '650' , y: '5.93' },
        { x: '651' , y: '5.93' },
        { x: '652' , y: '5.93' },
        { x: '653' , y: '5.93' },
        { x: '654' , y: '5.93' },
        { x: '655' , y: '5.93' },
        { x: '656' , y: '5.93' },
        { x: '657' , y: '5.93' },
        { x: '658' , y: '5.93' },
        { x: '659' , y: '5.93' },
        { x: '660' , y: '5.93' },
        { x: '661' , y: '5.93' },
        { x: '662' , y: '5.93' },
        { x: '663' , y: '5.93' },
        { x: '664' , y: '5.93' },
        { x: '665' , y: '5.93' },
        { x: '666' , y: '5.93' },
        { x: '667' , y: '5.93' },
        { x: '668' , y: '5.93' },
        { x: '669' , y: '5.93' },
        { x: '670' , y: '5.93' },
        { x: '671' , y: '5.93' },
        { x: '672' , y: '5.93' },
        { x: '673' , y: '5.93' },
        { x: '674' , y: '5.93' },
        { x: '675' , y: '5.93' },
        { x: '676' , y: '5.93' },
        { x: '677' , y: '5.93' },
        { x: '678' , y: '5.93' },
        { x: '679' , y: '5.93' },
        { x: '680' , y: '5.93' },
        { x: '681' , y: '5.93' },
        { x: '682' , y: '5.93' },
        { x: '683' , y: '5.93' },
        { x: '684' , y: '5.93' },
        { x: '685' , y: '5.93' },
        { x: '686' , y: '5.93' },
        { x: '687' , y: '5.93' },
        { x: '688' , y: '5.93' },
        { x: '689' , y: '5.93' },
        { x: '690' , y: '5.93' },
        { x: '691' , y: '5.93' },
        { x: '692' , y: '5.93' },
        { x: '693' , y: '5.93' },
        { x: '694' , y: '5.93' },
        { x: '695' , y: '5.93' },
        { x: '696' , y: '5.93' },
        { x: '697' , y: '5.93' },
        { x: '698' , y: '5.93' },
        { x: '699' , y: '5.93' },
        { x: '700' , y: '5.93' },
        { x: '701' , y: '5.93' },
        { x: '702' , y: '5.93' },
        { x: '703' , y: '5.93' },
        { x: '704' , y: '5.93' },
        { x: '705' , y: '5.93' },
        { x: '706' , y: '5.93' },
        { x: '707' , y: '5.93' },
        { x: '708' , y: '5.93' },
        { x: '709' , y: '5.93' },
        { x: '710' , y: '5.93' },
        { x: '711' , y: '5.93' },
        { x: '712' , y: '5.93' },
        { x: '713' , y: '5.93' },
        { x: '714' , y: '5.93' },
        { x: '715' , y: '5.93' },
        { x: '716' , y: '5.93' },
        { x: '717' , y: '5.93' },
        { x: '718' , y: '5.93' },
        { x: '719' , y: '5.93' },
        { x: '720' , y: '5.93' },
        { x: '721' , y: '5.93' },
        { x: '722' , y: '5.93' },
        { x: '723' , y: '5.93' },
        { x: '724' , y: '5.93' },
        { x: '725' , y: '5.93' },
        { x: '726' , y: '5.93' },
        { x: '727' , y: '6.01' },
        { x: '728' , y: '6.01' },
        { x: '729' , y: '6.01' },
        { x: '730' , y: '6.01' },
        { x: '731' , y: '6.01' },
        { x: '732' , y: '6.01' },
        { x: '733' , y: '6.01' },
        { x: '734' , y: '6.01' },
        { x: '735' , y: '6.01' },
        { x: '736' , y: '6.01' },
        { x: '737' , y: '6.01' },
        { x: '738' , y: '6.01' },
        { x: '739' , y: '6.01' },
        { x: '740' , y: '6.01' },
        { x: '741' , y: '6.01' },
        { x: '742' , y: '6.01' },
        { x: '743' , y: '6.01' },
        { x: '744' , y: '6.01' },
        { x: '745' , y: '6.01' },
        { x: '746' , y: '6.01' },
        { x: '747' , y: '6.01' },
        { x: '748' , y: '6.01' },
        { x: '749' , y: '6.01' },
        { x: '750' , y: '6.01' },
        { x: '751' , y: '6.01' },
        { x: '752' , y: '6.01' },
        { x: '753' , y: '6.01' },
        { x: '754' , y: '6.01' },
        { x: '755' , y: '6.01' },
        { x: '756' , y: '6.01' },
        { x: '757' , y: '6.01' },
        { x: '758' , y: '6.01' },
        { x: '759' , y: '6.01' },
        { x: '760' , y: '6.01' },
        { x: '761' , y: '6.01' },
        { x: '762' , y: '6.01' },
        { x: '763' , y: '6.01' },
        { x: '764' , y: '6.01' },
        { x: '765' , y: '6.01' },
        { x: '766' , y: '6.01' },
        { x: '767' , y: '6.01' },
        { x: '768' , y: '6.01' },
        { x: '769' , y: '6.01' },
        { x: '770' , y: '6.01' },
        { x: '771' , y: '6.01' },
        { x: '772' , y: '6.01' },
        { x: '773' , y: '6.01' },
        { x: '774' , y: '6.01' },
        { x: '775' , y: '6.01' },
        { x: '776' , y: '6.01' },
        { x: '777' , y: '6.01' },
        { x: '778' , y: '6.01' },
        { x: '779' , y: '6.01' },
        { x: '780' , y: '6.01' },
        { x: '781' , y: '6.01' },
        { x: '782' , y: '6.01' },
        { x: '783' , y: '6.01' },
        { x: '784' , y: '6.01' },
        { x: '785' , y: '6.01' },
        { x: '786' , y: '6.01' },
        { x: '787' , y: '6.01' },
        { x: '788' , y: '6.01' },
        { x: '789' , y: '6.01' },
        { x: '790' , y: '6.01' },
        { x: '791' , y: '6.01' },
        { x: '792' , y: '6.01' },
        { x: '793' , y: '6.01' },
        { x: '794' , y: '6.01' },
        { x: '795' , y: '6.01' },
        { x: '796' , y: '6.01' },
        { x: '797' , y: '6.01' },
        { x: '798' , y: '6.01' },
        { x: '799' , y: '6.01' },
        { x: '800' , y: '6.01' },
        { x: '801' , y: '6.01' },
        { x: '802' , y: '6.01' },
        { x: '803' , y: '6.01' },
        { x: '804' , y: '6.01' },
        { x: '805' , y: '6.01' },
        { x: '806' , y: '6.01' },
        { x: '807' , y: '6.01' },
        { x: '808' , y: '6.01' },
        { x: '809' , y: '6.01' },
        { x: '810' , y: '6.01' },
        { x: '811' , y: '6.01' },
        { x: '812' , y: '6.01' },
        { x: '813' , y: '6.01' },
        { x: '814' , y: '6.01' },
        { x: '815' , y: '6.01' },
        { x: '816' , y: '6.01' },
        { x: '817' , y: '6.01' },
        { x: '818' , y: '6.01' },
        { x: '819' , y: '6.01' },
        { x: '820' , y: '6.01' },
        { x: '821' , y: '6.01' },
        { x: '822' , y: '6.01' },
        { x: '823' , y: '6.01' },
        { x: '824' , y: '6.01' },
        { x: '825' , y: '6.01' },
        { x: '826' , y: '6.01' },
        { x: '827' , y: '6.01' },
        { x: '828' , y: '6.01' },
        { x: '829' , y: '6.01' },
        { x: '830' , y: '6.01' },
        { x: '831' , y: '6.01' },
        { x: '832' , y: '6.01' },
        { x: '833' , y: '6.01' },
        { x: '834' , y: '6.01' },
        { x: '835' , y: '6.01' },
        { x: '836' , y: '6.01' },
        { x: '837' , y: '6.01' },
        { x: '838' , y: '6.01' },
        { x: '839' , y: '6.01' },
        { x: '840' , y: '6.01' },
        { x: '841' , y: '6.01' },
        { x: '842' , y: '6.01' },
        { x: '843' , y: '6.01' },
        { x: '844' , y: '6.01' },
        { x: '845' , y: '6.01' },
        { x: '846' , y: '6.01' },
        { x: '847' , y: '6.01' },
        { x: '848' , y: '6.01' },
        { x: '849' , y: '6.01' },
        { x: '850' , y: '6.01' },
        { x: '851' , y: '6.01' },
        { x: '852' , y: '6.01' },
        { x: '853' , y: '6.01' },
        { x: '854' , y: '6.01' },
        { x: '855' , y: '6.01' },
        { x: '856' , y: '6.01' },
        { x: '857' , y: '6.01' },
        { x: '858' , y: '6.01' },
        { x: '859' , y: '6.01' },
        { x: '860' , y: '6.01' },
        { x: '861' , y: '6.01' },
        { x: '862' , y: '6.01' },
        { x: '863' , y: '6.01' },
        { x: '864' , y: '6.01' },
        { x: '865' , y: '6.01' },
        { x: '866' , y: '6.01' },
        { x: '867' , y: '6.01' },
        { x: '868' , y: '6.01' },
        { x: '869' , y: '6.01' },
        { x: '870' , y: '6.01' },
        { x: '871' , y: '6.01' },
        { x: '872' , y: '6.01' },
        { x: '873' , y: '6.01' },
        { x: '874' , y: '6.01' },
        { x: '875' , y: '6.01' },
        { x: '876' , y: '6.01' },
        { x: '877' , y: '6.01' },
        { x: '878' , y: '6.01' },
        { x: '879' , y: '6.01' },
        { x: '880' , y: '6.01' },
        { x: '881' , y: '6.01' },
        { x: '882' , y: '6.01' },
        { x: '883' , y: '6.01' },
        { x: '884' , y: '6.01' },
        { x: '885' , y: '6.01' },
        { x: '886' , y: '6.01' },
        { x: '887' , y: '6.01' },
        { x: '888' , y: '6.01' },
        { x: '889' , y: '6.01' },
        { x: '890' , y: '6.01' },
        { x: '891' , y: '6.01' },
        { x: '892' , y: '6.01' },
        { x: '893' , y: '6.01' },
        { x: '894' , y: '6.01' },
        { x: '895' , y: '6.01' },
        { x: '896' , y: '6.01' },
        { x: '897' , y: '6.01' },
        { x: '898' , y: '6.01' },
        { x: '899' , y: '6.01' },
        { x: '900' , y: '6.01' },
        { x: '901' , y: '6.01' },
        { x: '902' , y: '6.01' },
        { x: '903' , y: '6.01' },
        { x: '904' , y: '6.01' },
        { x: '905' , y: '6.01' },
        { x: '906' , y: '6.01' },
        { x: '907' , y: '6.01' },
        { x: '908' , y: '6.01' },
        { x: '909' , y: '6.01' },
        { x: '910' , y: '6.01' },
        { x: '911' , y: '6.01' },
        { x: '912' , y: '6.01' },
        { x: '913' , y: '6.01' },
        { x: '914' , y: '6.01' },
        { x: '915' , y: '6.01' },
        { x: '916' , y: '6.01' },
        { x: '917' , y: '6.01' },
        { x: '918' , y: '6.01' },
        { x: '919' , y: '6.01' },
        { x: '920' , y: '6.01' },
        { x: '921' , y: '6.01' },
        { x: '922' , y: '6.01' },
        { x: '923' , y: '6.01' },
        { x: '924' , y: '6.01' },
        { x: '925' , y: '6.01' },
        { x: '926' , y: '6.01' },
        { x: '927' , y: '6.01' },
        { x: '928' , y: '6.01' },
        { x: '929' , y: '6.01' },
        { x: '930' , y: '6.01' },
        { x: '931' , y: '6.01' },
        { x: '932' , y: '6.01' },
        { x: '933' , y: '6.01' },
        { x: '934' , y: '6.01' },
        { x: '935' , y: '6.01' },
        { x: '936' , y: '6.01' },
        { x: '937' , y: '6.01' },
        { x: '938' , y: '6.01' },
        { x: '939' , y: '6.01' },
        { x: '940' , y: '6.01' },
        { x: '941' , y: '6.01' },
        { x: '942' , y: '6.01' },
        { x: '943' , y: '6.01' },
        { x: '944' , y: '6.01' },
        { x: '945' , y: '6.01' },
        { x: '946' , y: '6.01' },
        { x: '947' , y: '6.01' },
        { x: '948' , y: '6.01' },
        { x: '949' , y: '6.01' },
        { x: '950' , y: '6.01' },
        { x: '951' , y: '6.01' },
        { x: '952' , y: '6.01' },
        { x: '953' , y: '6.01' },
        { x: '954' , y: '6.01' },
        { x: '955' , y: '6.01' },
        { x: '956' , y: '6.01' },
        { x: '957' , y: '6.01' },
        { x: '958' , y: '6.01' },
        { x: '959' , y: '6.01' },
        { x: '960' , y: '6.01' },
        { x: '961' , y: '6.01' },
        { x: '962' , y: '6.01' },
        { x: '963' , y: '6.01' },
        { x: '964' , y: '6.01' },
        { x: '965' , y: '6.01' },
        { x: '966' , y: '6.01' },
        { x: '967' , y: '6.01' },
        { x: '968' , y: '6.01' },
        { x: '969' , y: '6.01' },
        { x: '970' , y: '6.01' },
        { x: '971' , y: '6.01' },
        { x: '972' , y: '6.01' },
        { x: '973' , y: '6.01' },
        { x: '974' , y: '6.01' },
        { x: '975' , y: '6.01' },
        { x: '976' , y: '6.01' },
        { x: '977' , y: '6.01' },
        { x: '978' , y: '6.01' },
        { x: '979' , y: '6.01' },
        { x: '980' , y: '6.01' },
        { x: '981' , y: '6.01' },
        { x: '982' , y: '6.01' },
        { x: '983' , y: '6.01' },
        { x: '984' , y: '6.01' },
        { x: '985' , y: '6.01' },
        { x: '986' , y: '6.01' },
        { x: '987' , y: '6.01' },
        { x: '988' , y: '6.01' },
        { x: '989' , y: '6.01' },
        { x: '990' , y: '6.01' },
        { x: '991' , y: '6.01' },
        { x: '992' , y: '6.01' },
        { x: '993' , y: '6.01' },
        { x: '994' , y: '6.01' },
        { x: '995' , y: '6.01' },
        { x: '996' , y: '6.01' },
        { x: '997' , y: '6.01' },
        { x: '998' , y: '6.01' },
        { x: '999' , y: '6.01' },
        { x: '1000' , y: '5.98' },
        { x: '1001' , y: '5.98' },
        { x: '1002' , y: '5.98' },
        { x: '1003' , y: '5.98' },
        { x: '1004' , y: '5.98' },
        { x: '1005' , y: '5.98' },
        { x: '1006' , y: '5.98' },
        { x: '1007' , y: '5.98' },
        { x: '1008' , y: '5.98' },
        { x: '1009' , y: '5.98' },
        { x: '1010' , y: '5.98' },
        { x: '1011' , y: '5.98' },
        { x: '1012' , y: '5.98' },
        { x: '1013' , y: '5.98' },
        { x: '1014' , y: '5.98' },
        { x: '1015' , y: '5.98' },
        { x: '1016' , y: '5.98' },
        { x: '1017' , y: '5.98' },
        { x: '1018' , y: '5.98' },
        { x: '1019' , y: '5.98' },
        { x: '1020' , y: '5.98' },
        { x: '1021' , y: '5.98' },
        { x: '1022' , y: '5.98' },
        { x: '1023' , y: '5.98' },
        { x: '1024' , y: '5.98' },
        { x: '1025' , y: '5.98' },
        { x: '1026' , y: '5.98' },
        { x: '1027' , y: '5.98' },
        { x: '1028' , y: '5.98' },
        { x: '1029' , y: '5.98' },
        { x: '1030' , y: '5.98' },
        { x: '1031' , y: '5.98' },
        { x: '1032' , y: '5.98' },
        { x: '1033' , y: '5.98' },
        { x: '1034' , y: '5.98' },
        { x: '1035' , y: '5.98' },
        { x: '1036' , y: '5.98' },
        { x: '1037' , y: '5.98' },
        { x: '1038' , y: '5.98' },
        { x: '1039' , y: '5.98' },
        { x: '1040' , y: '5.98' },
        { x: '1041' , y: '5.98' },
        { x: '1042' , y: '5.98' },
        { x: '1043' , y: '5.98' },
        { x: '1044' , y: '5.98' },
        { x: '1045' , y: '5.98' },
        { x: '1046' , y: '5.98' },
        { x: '1047' , y: '5.98' },
        { x: '1048' , y: '5.98' },
        { x: '1049' , y: '5.98' },
        { x: '1050' , y: '5.98' },
        { x: '1051' , y: '5.98' },
        { x: '1052' , y: '5.98' },
        { x: '1053' , y: '5.98' },
        { x: '1054' , y: '5.98' },
        { x: '1055' , y: '5.98' },
        { x: '1056' , y: '5.98' },
        { x: '1057' , y: '5.98' },
        { x: '1058' , y: '5.98' },
        { x: '1059' , y: '5.98' },
        { x: '1060' , y: '5.98' },
        { x: '1061' , y: '5.98' },
        { x: '1062' , y: '5.98' },
        { x: '1063' , y: '5.98' },
        { x: '1064' , y: '5.98' },
        { x: '1065' , y: '5.98' },
        { x: '1066' , y: '5.98' },
        { x: '1067' , y: '5.98' },
        { x: '1068' , y: '5.98' },
        { x: '1069' , y: '5.98' },
        { x: '1070' , y: '5.98' },
        { x: '1071' , y: '5.98' },
        { x: '1072' , y: '5.98' },
        { x: '1073' , y: '5.98' },
        { x: '1074' , y: '5.98' },
        { x: '1075' , y: '5.98' },
        { x: '1076' , y: '5.98' },
        { x: '1077' , y: '5.98' },
        { x: '1078' , y: '5.98' },
        { x: '1079' , y: '5.98' },
        { x: '1080' , y: '5.98' },
        { x: '1081' , y: '5.98' },
        { x: '1082' , y: '5.98' },
        { x: '1083' , y: '5.98' },
        { x: '1084' , y: '5.98' },
        { x: '1085' , y: '5.98' },
        { x: '1086' , y: '5.98' },
        { x: '1087' , y: '5.98' },
        { x: '1088' , y: '5.98' },
        { x: '1089' , y: '5.98' },
        { x: '1090' , y: '5.98' },
        { x: '1091' , y: '5.98' },
        { x: '1092' , y: '5.98' },
        { x: '1093' , y: '5.98' },
        { x: '1094' , y: '5.98' },
        { x: '1095' , y: '5.98' },
        { x: '1096' , y: '5.98' },
        { x: '1097' , y: '5.98' },
        { x: '1098' , y: '5.98' },
        { x: '1099' , y: '5.98' },
        { x: '1100' , y: '5.98' },
        { x: '1101' , y: '5.98' },
        { x: '1102' , y: '5.98' },
        { x: '1103' , y: '5.98' },
        { x: '1104' , y: '5.98' },
        { x: '1105' , y: '5.98' },
        { x: '1106' , y: '5.98' },
        { x: '1107' , y: '5.98' },
        { x: '1108' , y: '5.98' },
        { x: '1109' , y: '5.98' },
        { x: '1110' , y: '5.98' },
        { x: '1111' , y: '5.98' },
        { x: '1112' , y: '5.98' },
        { x: '1113' , y: '5.98' },
        { x: '1114' , y: '5.98' },
        { x: '1115' , y: '5.98' },
        { x: '1116' , y: '5.98' },
        { x: '1117' , y: '5.98' },
        { x: '1118' , y: '5.98' },
        { x: '1119' , y: '5.98' },
        { x: '1120' , y: '5.98' },
        { x: '1121' , y: '5.98' },
        { x: '1122' , y: '5.98' },
        { x: '1123' , y: '5.98' },
        { x: '1124' , y: '5.98' },
        { x: '1125' , y: '5.98' },
        { x: '1126' , y: '5.98' },
        { x: '1127' , y: '5.98' },
        { x: '1128' , y: '5.98' },
        { x: '1129' , y: '5.98' },
        { x: '1130' , y: '5.98' },
        { x: '1131' , y: '5.98' },
        { x: '1132' , y: '5.98' },
        { x: '1133' , y: '5.98' },
        { x: '1134' , y: '5.98' },
        { x: '1135' , y: '5.98' },
        { x: '1136' , y: '5.98' },
        { x: '1137' , y: '5.98' },
        { x: '1138' , y: '5.98' },
        { x: '1139' , y: '5.98' },
        { x: '1140' , y: '5.98' },
        { x: '1141' , y: '5.98' },
        { x: '1142' , y: '5.98' },
        { x: '1143' , y: '5.98' },
        { x: '1144' , y: '5.98' },
        { x: '1145' , y: '5.98' },
        { x: '1146' , y: '5.98' },
        { x: '1147' , y: '5.98' },
        { x: '1148' , y: '5.98' },
        { x: '1149' , y: '5.98' },
        { x: '1150' , y: '5.98' },
        { x: '1151' , y: '5.98' },
        { x: '1152' , y: '5.98' },
        { x: '1153' , y: '5.98' },
        { x: '1154' , y: '5.98' },
        { x: '1155' , y: '5.98' },
        { x: '1156' , y: '5.98' },
        { x: '1157' , y: '5.98' },
        { x: '1158' , y: '5.98' },
        { x: '1159' , y: '5.98' },
        { x: '1160' , y: '5.98' },
        { x: '1161' , y: '5.98' },
        { x: '1162' , y: '5.98' },
        { x: '1163' , y: '5.98' },
        { x: '1164' , y: '5.98' },
        { x: '1165' , y: '5.98' },
        { x: '1166' , y: '5.98' },
        { x: '1167' , y: '5.98' },
        { x: '1168' , y: '5.98' },
        { x: '1169' , y: '5.98' },
        { x: '1170' , y: '5.98' },
        { x: '1171' , y: '5.98' },
        { x: '1172' , y: '5.98' },
        { x: '1173' , y: '5.98' },
        { x: '1174' , y: '5.98' },
        { x: '1175' , y: '5.98' },
        { x: '1176' , y: '5.98' },
        { x: '1177' , y: '5.98' },
        { x: '1178' , y: '5.98' },
        { x: '1179' , y: '5.98' },
        { x: '1180' , y: '5.98' },
        { x: '1181' , y: '5.98' },
        { x: '1182' , y: '5.98' },
        { x: '1183' , y: '5.98' },
        { x: '1184' , y: '5.98' },
        { x: '1185' , y: '5.98' },
        { x: '1186' , y: '5.98' },
        { x: '1187' , y: '5.98' },
        { x: '1188' , y: '5.98' },
        { x: '1189' , y: '5.98' },
        { x: '1190' , y: '5.98' },
        { x: '1191' , y: '5.98' },
        { x: '1192' , y: '5.98' },
        { x: '1193' , y: '5.98' },
        { x: '1194' , y: '5.98' },
        { x: '1195' , y: '5.98' },
        { x: '1196' , y: '5.98' },
        { x: '1197' , y: '5.98' },
        { x: '1198' , y: '5.97' },
        { x: '1199' , y: '5.97' },
        { x: '1200' , y: '5.97' },
        { x: '1201' , y: '5.97' },
        { x: '1202' , y: '5.97' },
        { x: '1203' , y: '5.97' },
        { x: '1204' , y: '5.97' },
        { x: '1205' , y: '5.97' },
        { x: '1206' , y: '5.97' },
        { x: '1207' , y: '5.97' },
        { x: '1208' , y: '5.97' },
        { x: '1209' , y: '5.97' },
        { x: '1210' , y: '5.97' },
        { x: '1211' , y: '5.97' },
        { x: '1212' , y: '5.97' },
        { x: '1213' , y: '5.97' },
        { x: '1214' , y: '5.97' },
        { x: '1215' , y: '5.97' },
        { x: '1216' , y: '5.97' },
        { x: '1217' , y: '5.97' },
        { x: '1218' , y: '5.97' },
        { x: '1219' , y: '5.97' },
        { x: '1220' , y: '5.97' },
        { x: '1221' , y: '5.97' },
        { x: '1222' , y: '5.97' },
        { x: '1223' , y: '5.97' },
        { x: '1224' , y: '5.97' },
        { x: '1225' , y: '5.97' },
        { x: '1226' , y: '5.97' },
        { x: '1227' , y: '5.97' },
        { x: '1228' , y: '5.97' },
        { x: '1229' , y: '5.97' },
        { x: '1230' , y: '5.97' },
        { x: '1231' , y: '5.97' },
        { x: '1232' , y: '5.97' },
        { x: '1233' , y: '5.97' },
        { x: '1234' , y: '5.97' },
        { x: '1235' , y: '5.97' },
        { x: '1236' , y: '5.97' },
        { x: '1237' , y: '5.97' },
        { x: '1238' , y: '5.97' },
        { x: '1239' , y: '5.97' },
        { x: '1240' , y: '5.97' },
        { x: '1241' , y: '5.97' },
        { x: '1242' , y: '5.97' },
        { x: '1243' , y: '5.97' },
        { x: '1244' , y: '5.97' },
        { x: '1245' , y: '5.97' },
        { x: '1246' , y: '5.97' },
        { x: '1247' , y: '5.97' },
        { x: '1248' , y: '5.97' },
        { x: '1249' , y: '5.97' },
        { x: '1250' , y: '5.97' },
        { x: '1251' , y: '5.97' },
        { x: '1252' , y: '5.97' },
        { x: '1253' , y: '5.97' },
        { x: '1254' , y: '5.97' },
        { x: '1255' , y: '5.97' },
        { x: '1256' , y: '5.97' },
        { x: '1257' , y: '5.97' },
        { x: '1258' , y: '5.97' },
        { x: '1259' , y: '5.97' },
        { x: '1260' , y: '5.97' },
        { x: '1261' , y: '5.97' },
        { x: '1262' , y: '5.97' },
        { x: '1263' , y: '5.97' },
        { x: '1264' , y: '5.97' },
        { x: '1265' , y: '5.97' },
        { x: '1266' , y: '5.97' },
        { x: '1267' , y: '5.97' },
        { x: '1268' , y: '5.97' },
        { x: '1269' , y: '5.97' },
        { x: '1270' , y: '5.97' },
        { x: '1271' , y: '5.97' },
        { x: '1272' , y: '5.97' },
        { x: '1273' , y: '5.97' },
        { x: '1274' , y: '5.97' },
        { x: '1275' , y: '5.97' },
        { x: '1276' , y: '5.97' },
        { x: '1277' , y: '5.97' },
        { x: '1278' , y: '5.97' },
        { x: '1279' , y: '5.97' },
        { x: '1280' , y: '5.97' },
        { x: '1281' , y: '5.97' },
        { x: '1282' , y: '5.97' },
        { x: '1283' , y: '5.97' },
        { x: '1284' , y: '5.97' },
        { x: '1285' , y: '5.97' },
        { x: '1286' , y: '5.97' },
        { x: '1287' , y: '5.97' },
        { x: '1288' , y: '5.97' },
        { x: '1289' , y: '5.97' },
        { x: '1290' , y: '5.97' },
        { x: '1291' , y: '5.97' },
        { x: '1292' , y: '5.97' },
        { x: '1293' , y: '5.97' },
        { x: '1294' , y: '5.97' },
        { x: '1295' , y: '5.97' },
        { x: '1296' , y: '5.97' },
        { x: '1297' , y: '5.97' },
        { x: '1298' , y: '5.97' },
        { x: '1299' , y: '5.97' },
        { x: '1300' , y: '5.97' },
        { x: '1301' , y: '5.97' },
        { x: '1302' , y: '5.97' },
        { x: '1303' , y: '5.97' },
        { x: '1304' , y: '5.97' },
        { x: '1305' , y: '5.97' },
        { x: '1306' , y: '5.97' },
        { x: '1307' , y: '5.97' },
        { x: '1308' , y: '5.97' },
        { x: '1309' , y: '5.97' },
        { x: '1310' , y: '5.97' },
        { x: '1311' , y: '5.97' },
        { x: '1312' , y: '5.97' },
        { x: '1313' , y: '5.97' },
        { x: '1314' , y: '5.97' },
        { x: '1315' , y: '5.97' },
        { x: '1316' , y: '5.97' },
        { x: '1317' , y: '5.97' },
        { x: '1318' , y: '5.97' },
        { x: '1319' , y: '5.97' },
        { x: '1320' , y: '5.97' },
        { x: '1321' , y: '5.97' },
        { x: '1322' , y: '5.97' },
        { x: '1323' , y: '5.97' },
        { x: '1324' , y: '5.97' },
        { x: '1325' , y: '5.97' },
        { x: '1326' , y: '5.97' },
        { x: '1327' , y: '5.97' },
        { x: '1328' , y: '5.97' },
        { x: '1329' , y: '5.97' },
        { x: '1330' , y: '5.97' },
        { x: '1331' , y: '5.97' },
        { x: '1332' , y: '5.97' },
        { x: '1333' , y: '5.97' },
        { x: '1334' , y: '5.97' },
        { x: '1335' , y: '5.97' },
        { x: '1336' , y: '5.97' },
        { x: '1337' , y: '5.97' },
        { x: '1338' , y: '5.97' },
        { x: '1339' , y: '5.97' },
        { x: '1340' , y: '5.97' },
        { x: '1341' , y: '5.97' },
        { x: '1342' , y: '5.97' },
        { x: '1343' , y: '5.97' },
        { x: '1344' , y: '5.97' },
        { x: '1345' , y: '5.97' },
        { x: '1346' , y: '5.97' },
        { x: '1347' , y: '5.97' },
        { x: '1348' , y: '5.97' },
        { x: '1349' , y: '5.97' },
        { x: '1350' , y: '5.97' },
        { x: '1351' , y: '5.97' },
        { x: '1352' , y: '5.97' },
        { x: '1353' , y: '5.97' },
        { x: '1354' , y: '5.97' },
        { x: '1355' , y: '5.97' },
        { x: '1356' , y: '5.97' },
        { x: '1357' , y: '5.97' },
        { x: '1358' , y: '5.97' },
        { x: '1359' , y: '5.97' },
        { x: '1360' , y: '5.97' },
        { x: '1361' , y: '5.97' },
        { x: '1362' , y: '5.97' },
        { x: '1363' , y: '5.97' },
        { x: '1364' , y: '5.97' },
        { x: '1365' , y: '5.97' },
        { x: '1366' , y: '5.97' },
        { x: '1367' , y: '5.97' },
        { x: '1368' , y: '5.97' },
        { x: '1369' , y: '5.97' },
        { x: '1370' , y: '5.97' },
        { x: '1371' , y: '5.97' },
        { x: '1372' , y: '5.97' },
        { x: '1373' , y: '5.97' },
        { x: '1374' , y: '5.97' },
        { x: '1375' , y: '5.97' },
        { x: '1376' , y: '5.97' },
        { x: '1377' , y: '5.97' },
        { x: '1378' , y: '5.97' },
        { x: '1379' , y: '5.97' },
        { x: '1380' , y: '5.97' },
        { x: '1381' , y: '5.97' },
        { x: '1382' , y: '5.97' },
        { x: '1383' , y: '5.97' },
        { x: '1384' , y: '5.97' },
        { x: '1385' , y: '5.97' },
        { x: '1386' , y: '5.97' },
        { x: '1387' , y: '5.97' },
        { x: '1388' , y: '5.97' },
        { x: '1389' , y: '5.97' },
        { x: '1390' , y: '5.97' },
        { x: '1391' , y: '5.97' },
        { x: '1392' , y: '5.97' },
        { x: '1393' , y: '5.97' },
        { x: '1394' , y: '5.97' },
        { x: '1395' , y: '5.97' },
        { x: '1396' , y: '5.97' },
        { x: '1397' , y: '5.97' },
        { x: '1398' , y: '5.97' },
        { x: '1399' , y: '5.97' },
        { x: '1400' , y: '5.97' },
        { x: '1401' , y: '5.95' },
        { x: '1402' , y: '5.95' },
        { x: '1403' , y: '5.95' },
        { x: '1404' , y: '5.95' },
        { x: '1405' , y: '5.95' },
        { x: '1406' , y: '5.95' },
        { x: '1407' , y: '5.95' },
        { x: '1408' , y: '5.95' },
        { x: '1409' , y: '5.95' },
        { x: '1410' , y: '5.95' },
        { x: '1411' , y: '5.95' },
        { x: '1412' , y: '5.95' },
        { x: '1413' , y: '5.95' },
        { x: '1414' , y: '5.95' },
        { x: '1415' , y: '5.95' },
        { x: '1416' , y: '5.95' },
        { x: '1417' , y: '5.95' },
        { x: '1418' , y: '5.95' },
        { x: '1419' , y: '5.95' },
        { x: '1420' , y: '5.95' },
        { x: '1421' , y: '5.95' },
        { x: '1422' , y: '5.95' },
        { x: '1423' , y: '5.95' },
        { x: '1424' , y: '5.95' },
        { x: '1425' , y: '5.95' },
        { x: '1426' , y: '5.95' },
        { x: '1427' , y: '5.95' },
        { x: '1428' , y: '5.95' },
        { x: '1429' , y: '5.95' },
        { x: '1430' , y: '5.95' },
        { x: '1431' , y: '5.95' },
        { x: '1432' , y: '5.95' },
        { x: '1433' , y: '5.95' },
        { x: '1434' , y: '5.95' },
        { x: '1435' , y: '5.95' },
        { x: '1436' , y: '5.95' },
        { x: '1437' , y: '5.95' },
        { x: '1438' , y: '5.95' },
        { x: '1439' , y: '5.95' },
        { x: '1440' , y: '5.95' },
        { x: '1441' , y: '5.95' },
        { x: '1442' , y: '5.95' },
        { x: '1443' , y: '5.95' },
        { x: '1444' , y: '5.95' },
        { x: '1445' , y: '5.95' },
        { x: '1446' , y: '5.95' },
        { x: '1447' , y: '5.95' },
        { x: '1448' , y: '5.95' },
        { x: '1449' , y: '5.95' },
        { x: '1450' , y: '5.95' },
        { x: '1451' , y: '5.95' },
        { x: '1452' , y: '5.95' },
        { x: '1453' , y: '5.95' },
        { x: '1454' , y: '5.95' },
        { x: '1455' , y: '5.95' },
        { x: '1456' , y: '5.95' },
        { x: '1457' , y: '5.95' },
        { x: '1458' , y: '5.95' },
        { x: '1459' , y: '5.95' },
        { x: '1460' , y: '5.95' },
        { x: '1461' , y: '5.95' },
        { x: '1462' , y: '5.95' },
        { x: '1463' , y: '5.95' },
        { x: '1464' , y: '5.95' },
        { x: '1465' , y: '5.95' },
        { x: '1466' , y: '5.95' },
        { x: '1467' , y: '5.95' },
        { x: '1468' , y: '5.95' },
        { x: '1469' , y: '5.95' },
        { x: '1470' , y: '5.95' },
        { x: '1471' , y: '5.95' },
        { x: '1472' , y: '5.95' },
        { x: '1473' , y: '5.95' },
        { x: '1474' , y: '5.95' },
        { x: '1475' , y: '5.95' },
        { x: '1476' , y: '5.95' },
        { x: '1477' , y: '5.95' },
        { x: '1478' , y: '5.95' },
        { x: '1479' , y: '5.95' },
        { x: '1480' , y: '5.95' },
        { x: '1481' , y: '5.95' },
        { x: '1482' , y: '5.95' },
        { x: '1483' , y: '5.95' },
        { x: '1484' , y: '5.95' },
        { x: '1485' , y: '5.95' },
        { x: '1486' , y: '5.95' },
        { x: '1487' , y: '5.95' },
        { x: '1488' , y: '5.95' },
        { x: '1489' , y: '5.95' },
        { x: '1490' , y: '5.95' },
        { x: '1491' , y: '5.95' },
        { x: '1492' , y: '5.95' },
        { x: '1493' , y: '5.95' },
        { x: '1494' , y: '5.95' },
        { x: '1495' , y: '5.95' },
        { x: '1496' , y: '5.95' },
        { x: '1497' , y: '5.95' },
        { x: '1498' , y: '5.95' },
        { x: '1499' , y: '5.95' },
        { x: '1500' , y: '5.95' },
        { x: '1501' , y: '5.95' },
        { x: '1502' , y: '5.95' },
        { x: '1503' , y: '5.95' },
        { x: '1504' , y: '5.95' },
        { x: '1505' , y: '5.95' },
        { x: '1506' , y: '5.95' },
        { x: '1507' , y: '5.95' },
        { x: '1508' , y: '5.95' },
        { x: '1509' , y: '5.95' },
        { x: '1510' , y: '5.95' },
        { x: '1511' , y: '5.95' },
        { x: '1512' , y: '5.95' },
        { x: '1513' , y: '5.95' },
        { x: '1514' , y: '5.95' },
        { x: '1515' , y: '5.95' },
        { x: '1516' , y: '5.95' },
        { x: '1517' , y: '5.95' },
        { x: '1518' , y: '5.95' },
        { x: '1519' , y: '5.95' },
        { x: '1520' , y: '5.95' },
        { x: '1521' , y: '5.95' },
        { x: '1522' , y: '5.95' },
        { x: '1523' , y: '5.95' },
        { x: '1524' , y: '5.95' },
        { x: '1525' , y: '5.95' },
        { x: '1526' , y: '5.95' },
        { x: '1527' , y: '5.95' },
        { x: '1528' , y: '5.95' },
        { x: '1529' , y: '5.95' },
        { x: '1530' , y: '5.95' },
        { x: '1531' , y: '5.95' },
        { x: '1532' , y: '5.95' },
        { x: '1533' , y: '5.95' },
        { x: '1534' , y: '5.95' },
        { x: '1535' , y: '5.95' },
        { x: '1536' , y: '5.95' },
        { x: '1537' , y: '5.95' },
        { x: '1538' , y: '5.95' },
        { x: '1539' , y: '5.95' },
        { x: '1540' , y: '5.95' },
        { x: '1541' , y: '5.95' },
        { x: '1542' , y: '5.95' },
        { x: '1543' , y: '5.95' },
        { x: '1544' , y: '5.95' },
        { x: '1545' , y: '5.95' },
        { x: '1546' , y: '5.95' },
        { x: '1547' , y: '5.95' },
        { x: '1548' , y: '5.95' },
        { x: '1549' , y: '5.95' },
        { x: '1550' , y: '5.95' },
        { x: '1551' , y: '5.95' },
        { x: '1552' , y: '5.95' },
        { x: '1553' , y: '5.95' },
        { x: '1554' , y: '5.95' },
        { x: '1555' , y: '5.95' },
        { x: '1556' , y: '5.95' },
        { x: '1557' , y: '5.95' },
        { x: '1558' , y: '5.95' },
        { x: '1559' , y: '5.95' },
        { x: '1560' , y: '5.95' },
        { x: '1561' , y: '5.95' },
        { x: '1562' , y: '5.95' },
        { x: '1563' , y: '5.95' },
        { x: '1564' , y: '5.95' },
        { x: '1565' , y: '5.95' },
        { x: '1566' , y: '5.95' },
        { x: '1567' , y: '5.95' },
        { x: '1568' , y: '5.95' },
        { x: '1569' , y: '5.95' },
        { x: '1570' , y: '5.95' },
        { x: '1571' , y: '5.95' },
        { x: '1572' , y: '5.95' },
        { x: '1573' , y: '5.95' },
        { x: '1574' , y: '5.95' },
        { x: '1575' , y: '5.95' },
        { x: '1576' , y: '5.95' },
        { x: '1577' , y: '5.95' },
        { x: '1578' , y: '5.95' },
        { x: '1579' , y: '5.95' },
        { x: '1580' , y: '5.95' },
        { x: '1581' , y: '5.95' },
        { x: '1582' , y: '5.95' },
        { x: '1583' , y: '5.95' },
        { x: '1584' , y: '5.95' },
        { x: '1585' , y: '5.95' },
        { x: '1586' , y: '5.95' },
        { x: '1587' , y: '5.95' },
        { x: '1588' , y: '5.95' },
        { x: '1589' , y: '5.95' },
        { x: '1590' , y: '5.95' },
        { x: '1591' , y: '5.95' },
        { x: '1592' , y: '5.95' },
        { x: '1593' , y: '5.95' },
        { x: '1594' , y: '5.95' },
        { x: '1595' , y: '5.95' },
        { x: '1596' , y: '5.95' },
        { x: '1597' , y: '5.95' },
        { x: '1598' , y: '5.95' },
        { x: '1599' , y: '5.95' },
        { x: '1600' , y: '5.95' },
        { x: '1601' , y: '5.95' },
        { x: '1602' , y: '5.95' },
        { x: '1603' , y: '5.95' },
        { x: '1604' , y: '5.95' },
        { x: '1605' , y: '5.95' },
        { x: '1606' , y: '5.95' },
        { x: '1607' , y: '5.95' },
        { x: '1608' , y: '5.95' },
        { x: '1609' , y: '5.95' },
        { x: '1610' , y: '5.95' },
        { x: '1611' , y: '5.95' },
        { x: '1612' , y: '5.95' },
        { x: '1613' , y: '5.95' },
        { x: '1614' , y: '5.95' },
        { x: '1615' , y: '5.95' },
        { x: '1616' , y: '5.95' },
        { x: '1617' , y: '5.95' },
        { x: '1618' , y: '5.95' },
        { x: '1619' , y: '5.95' },
        { x: '1620' , y: '5.95' },
        { x: '1621' , y: '5.95' },
        { x: '1622' , y: '5.95' },
        { x: '1623' , y: '5.95' },
        { x: '1624' , y: '5.95' },
        { x: '1625' , y: '5.95' },
        { x: '1626' , y: '5.95' },
        { x: '1627' , y: '5.95' },
        { x: '1628' , y: '5.95' },
        { x: '1629' , y: '5.95' },
        { x: '1630' , y: '5.95' },
        { x: '1631' , y: '5.95' },
        { x: '1632' , y: '5.95' },
        { x: '1633' , y: '5.95' },
        { x: '1634' , y: '5.95' },
        { x: '1635' , y: '5.95' },
        { x: '1636' , y: '5.95' },
        { x: '1637' , y: '5.95' },
        { x: '1638' , y: '5.95' },
        { x: '1639' , y: '5.95' },
        { x: '1640' , y: '5.95' },
        { x: '1641' , y: '5.95' },
        { x: '1642' , y: '5.95' },
        { x: '1643' , y: '5.95' },
        { x: '1644' , y: '5.95' },
        { x: '1645' , y: '5.95' },
        { x: '1646' , y: '5.95' },
        { x: '1647' , y: '5.95' },
        { x: '1648' , y: '5.95' },
        { x: '1649' , y: '5.95' },
        { x: '1650' , y: '5.95' },
        { x: '1651' , y: '5.95' },
        { x: '1652' , y: '5.95' },
        { x: '1653' , y: '5.95' },
        { x: '1654' , y: '5.95' },
        { x: '1655' , y: '5.95' },
        { x: '1656' , y: '5.95' },
        { x: '1657' , y: '5.95' },
        { x: '1658' , y: '5.95' },
        { x: '1659' , y: '5.95' },
        { x: '1660' , y: '5.95' },
        { x: '1661' , y: '5.95' },
        { x: '1662' , y: '5.95' },
        { x: '1663' , y: '5.95' },
        { x: '1664' , y: '5.95' },
        { x: '1665' , y: '5.95' },
        { x: '1666' , y: '5.95' },
        { x: '1667' , y: '5.95' },
        { x: '1668' , y: '5.95' },
        { x: '1669' , y: '5.95' },
        { x: '1670' , y: '5.95' },
        { x: '1671' , y: '5.95' },
        { x: '1672' , y: '5.95' },
        { x: '1673' , y: '5.95' },
        { x: '1674' , y: '5.95' },
        { x: '1675' , y: '5.95' },
        { x: '1676' , y: '5.95' },
        { x: '1677' , y: '5.95' },
        { x: '1678' , y: '5.95' },
        { x: '1679' , y: '5.95' },
        { x: '1680' , y: '5.95' },
        { x: '1681' , y: '5.95' },
        { x: '1682' , y: '5.95' },
        { x: '1683' , y: '5.95' },
        { x: '1684' , y: '5.95' },
        { x: '1685' , y: '5.95' },
        { x: '1686' , y: '5.95' },
        { x: '1687' , y: '5.95' },
        { x: '1688' , y: '5.95' },
        { x: '1689' , y: '5.95' },
        { x: '1690' , y: '5.95' },
        { x: '1691' , y: '5.95' },
        { x: '1692' , y: '5.95' },
        { x: '1693' , y: '5.95' },
        { x: '1694' , y: '5.95' },
        { x: '1695' , y: '5.95' },
        { x: '1696' , y: '5.95' },
        { x: '1697' , y: '5.95' },
        { x: '1698' , y: '5.95' },
        { x: '1699' , y: '5.95' },
        { x: '1700' , y: '5.95' },
        { x: '1701' , y: '5.95' },
        { x: '1702' , y: '5.95' },
        { x: '1703' , y: '5.95' },
        { x: '1704' , y: '5.95' },
        { x: '1705' , y: '5.95' },
        { x: '1706' , y: '5.95' },
        { x: '1707' , y: '5.95' },
        { x: '1708' , y: '5.95' },
        { x: '1709' , y: '5.95' },
        { x: '1710' , y: '5.95' },
        { x: '1711' , y: '5.95' },
        { x: '1712' , y: '5.95' },
        { x: '1713' , y: '5.95' },
        { x: '1714' , y: '5.95' },
        { x: '1715' , y: '5.95' },
        { x: '1716' , y: '5.95' },
        { x: '1717' , y: '5.95' },
        { x: '1718' , y: '5.95' },
        { x: '1719' , y: '5.95' },
        { x: '1720' , y: '5.95' },
        { x: '1721' , y: '5.95' },
        { x: '1722' , y: '5.95' },
        { x: '1723' , y: '5.95' },
        { x: '1724' , y: '5.95' },
        { x: '1725' , y: '5.95' },
        { x: '1726' , y: '5.95' },
        { x: '1727' , y: '5.95' },
        { x: '1728' , y: '5.95' },
        { x: '1729' , y: '5.95' },
        { x: '1730' , y: '5.95' },
        { x: '1731' , y: '5.95' },
        { x: '1732' , y: '5.95' },
        { x: '1733' , y: '5.95' },
        { x: '1734' , y: '5.95' },
        { x: '1735' , y: '5.95' },
        { x: '1736' , y: '5.95' },
        { x: '1737' , y: '5.95' },
        { x: '1738' , y: '5.95' },
        { x: '1739' , y: '5.95' },
        { x: '1740' , y: '5.95' },
        { x: '1741' , y: '5.95' },
        { x: '1742' , y: '5.95' },
        { x: '1743' , y: '5.95' },
        { x: '1744' , y: '5.95' },
        { x: '1745' , y: '5.95' },
        { x: '1746' , y: '5.95' },
        { x: '1747' , y: '5.95' },
        { x: '1748' , y: '5.95' },
        { x: '1749' , y: '5.95' },
        { x: '1750' , y: '5.95' },
        { x: '1751' , y: '5.95' },
        { x: '1752' , y: '5.95' },
        { x: '1753' , y: '5.95' },
        { x: '1754' , y: '5.95' },
        { x: '1755' , y: '5.95' },
        { x: '1756' , y: '5.95' },
        { x: '1757' , y: '5.95' },
        { x: '1758' , y: '5.95' },
        { x: '1759' , y: '5.95' },
        { x: '1760' , y: '5.95' },
        { x: '1761' , y: '5.95' },
        { x: '1762' , y: '5.95' },
        { x: '1763' , y: '5.95' },
        { x: '1764' , y: '5.95' },
        { x: '1765' , y: '5.95' },
        { x: '1766' , y: '5.95' },
        { x: '1767' , y: '5.95' },
        { x: '1768' , y: '5.95' },
        { x: '1769' , y: '5.95' },
        { x: '1770' , y: '5.95' },
        { x: '1771' , y: '5.95' },
        { x: '1772' , y: '5.95' },
        { x: '1773' , y: '5.95' },
        { x: '1774' , y: '5.95' },
        { x: '1775' , y: '5.95' },
        { x: '1776' , y: '5.95' },
        { x: '1777' , y: '5.95' },
        { x: '1778' , y: '5.95' },
        { x: '1779' , y: '5.95' },
        { x: '1780' , y: '5.95' },
        { x: '1781' , y: '5.95' },
        { x: '1782' , y: '5.95' },
        { x: '1783' , y: '5.95' },
        { x: '1784' , y: '5.95' },
        { x: '1785' , y: '5.95' },
        { x: '1786' , y: '5.95' },
        { x: '1787' , y: '5.95' },
        { x: '1788' , y: '5.95' },
        { x: '1789' , y: '5.95' },
        { x: '1790' , y: '5.95' },
        { x: '1791' , y: '5.95' },
        { x: '1792' , y: '5.95' },
        { x: '1793' , y: '5.95' },
        { x: '1794' , y: '5.95' },
        { x: '1795' , y: '5.95' },
        { x: '1796' , y: '5.95' },
        { x: '1797' , y: '5.95' },
        { x: '1798' , y: '5.95' },
        { x: '1799' , y: '5.95' },
        { x: '1800' , y: '5.95' },
        { x: '1801' , y: '5.95' },
        { x: '1802' , y: '5.95' },
        { x: '1803' , y: '5.95' },
        { x: '1804' , y: '5.95' },
        { x: '1805' , y: '5.95' },
        { x: '1806' , y: '5.95' },
        { x: '1807' , y: '5.95' },
        { x: '1808' , y: '5.95' },
        { x: '1809' , y: '5.95' },
        { x: '1810' , y: '5.95' },
        { x: '1811' , y: '5.95' },
        { x: '1812' , y: '5.95' },
        { x: '1813' , y: '5.95' },
        { x: '1814' , y: '5.95' },
        { x: '1815' , y: '5.95' },
        { x: '1816' , y: '5.95' },
        { x: '1817' , y: '5.95' },
        { x: '1818' , y: '5.95' },
        { x: '1819' , y: '5.95' },
        { x: '1820' , y: '5.95' },
        { x: '1821' , y: '5.95' },
        { x: '1822' , y: '5.95' },
        { x: '1823' , y: '5.95' },
        { x: '1824' , y: '5.95' },
        { x: '1825' , y: '5.95' },
        { x: '1826' , y: '5.95' },
        { x: '1827' , y: '5.95' },
        { x: '1828' , y: '5.95' },
        { x: '1829' , y: '5.95' },
        { x: '1830' , y: '5.95' },
        { x: '1831' , y: '5.95' },
        { x: '1832' , y: '5.95' },
        { x: '1833' , y: '5.95' },
        { x: '1834' , y: '5.95' },
        { x: '1835' , y: '5.95' },
        { x: '1836' , y: '5.95' },
        { x: '1837' , y: '5.95' },
        { x: '1838' , y: '5.95' },
        { x: '1839' , y: '5.95' },
        { x: '1840' , y: '5.95' },
        { x: '1841' , y: '5.95' },
        { x: '1842' , y: '5.95' },
        { x: '1843' , y: '5.95' },
        { x: '1844' , y: '5.95' },
        { x: '1845' , y: '5.95' },
        { x: '1846' , y: '5.95' },
        { x: '1847' , y: '5.95' },
        { x: '1848' , y: '5.95' },
        { x: '1849' , y: '5.95' },
        { x: '1850' , y: '5.95' },
        { x: '1851' , y: '5.95' },
        { x: '1852' , y: '5.95' },
        { x: '1853' , y: '5.95' },
        { x: '1854' , y: '5.95' },
        { x: '1855' , y: '5.95' },
        { x: '1856' , y: '5.95' },
        { x: '1857' , y: '5.95' },
        { x: '1858' , y: '5.95' },
        { x: '1859' , y: '5.95' },
        { x: '1860' , y: '5.95' },
        { x: '1861' , y: '5.95' },
        { x: '1862' , y: '5.95' },
        { x: '1863' , y: '5.95' },
        { x: '1864' , y: '5.95' },
        { x: '1865' , y: '5.95' },
        { x: '1866' , y: '5.95' },
        { x: '1867' , y: '5.95' },
        { x: '1868' , y: '5.95' },
        { x: '1869' , y: '5.95' },
        { x: '1870' , y: '5.95' },
        { x: '1871' , y: '5.95' },
        { x: '1872' , y: '5.95' },
        { x: '1873' , y: '5.95' },
        { x: '1874' , y: '5.95' },
        { x: '1875' , y: '5.95' },
        { x: '1876' , y: '5.95' },
        { x: '1877' , y: '5.95' },
        { x: '1878' , y: '5.95' },
        { x: '1879' , y: '5.95' },
        { x: '1880' , y: '5.95' },
        { x: '1881' , y: '5.95' },
        { x: '1882' , y: '5.95' },
        { x: '1883' , y: '5.95' },
        { x: '1884' , y: '5.95' },
        { x: '1885' , y: '5.95' },
        { x: '1886' , y: '5.95' },
        { x: '1887' , y: '5.95' },
        { x: '1888' , y: '5.95' },
        { x: '1889' , y: '5.95' },
        { x: '1890' , y: '5.95' },
        { x: '1891' , y: '5.95' },
        { x: '1892' , y: '5.95' },
        { x: '1893' , y: '5.95' },
        { x: '1894' , y: '5.95' },
        { x: '1895' , y: '5.95' },
        { x: '1896' , y: '5.95' },
        { x: '1897' , y: '5.95' },
        { x: '1898' , y: '5.95' },
        { x: '1899' , y: '5.95' },
        { x: '1900' , y: '5.95' },
        { x: '1901' , y: '5.95' },
        { x: '1902' , y: '5.95' },
        { x: '1903' , y: '5.95' },
        { x: '1904' , y: '5.95' },
        { x: '1905' , y: '5.95' },
        { x: '1906' , y: '5.95' },
        { x: '1907' , y: '5.95' },
        { x: '1908' , y: '5.95' },
        { x: '1909' , y: '5.95' },
        { x: '1910' , y: '5.95' },
        { x: '1911' , y: '5.95' },
        { x: '1912' , y: '5.95' },
        { x: '1913' , y: '5.95' },
        { x: '1914' , y: '5.95' },
        { x: '1915' , y: '5.95' },
        { x: '1916' , y: '5.95' },
        { x: '1917' , y: '5.95' },
        { x: '1918' , y: '5.95' },
        { x: '1919' , y: '5.95' },
        { x: '1920' , y: '5.95' },
        { x: '1921' , y: '5.95' },
        { x: '1922' , y: '5.95' },
        { x: '1923' , y: '5.95' },
        { x: '1924' , y: '5.95' },
        { x: '1925' , y: '5.95' },
        { x: '1926' , y: '5.95' },
        { x: '1927' , y: '5.95' },
        { x: '1928' , y: '5.95' },
        { x: '1929' , y: '5.95' },
        { x: '1930' , y: '5.95' },
        { x: '1931' , y: '5.95' },
        { x: '1932' , y: '5.95' },
        { x: '1933' , y: '5.95' },
        { x: '1934' , y: '5.95' },
        { x: '1935' , y: '5.95' },
        { x: '1936' , y: '5.95' },
        { x: '1937' , y: '5.95' },
        { x: '1938' , y: '5.95' },
        { x: '1939' , y: '5.95' },
        { x: '1940' , y: '5.95' },
        { x: '1941' , y: '5.95' },
        { x: '1942' , y: '5.95' },
        { x: '1943' , y: '5.95' },
        { x: '1944' , y: '5.95' },
        { x: '1945' , y: '5.95' },
        { x: '1946' , y: '5.95' },
        { x: '1947' , y: '5.95' },
        { x: '1948' , y: '5.95' },
        { x: '1949' , y: '5.95' },
        { x: '1950' , y: '5.95' },
        { x: '1951' , y: '5.95' },
        { x: '1952' , y: '5.95' },
        { x: '1953' , y: '5.95' },
        { x: '1954' , y: '5.95' },
        { x: '1955' , y: '5.95' },
        { x: '1956' , y: '5.95' },
        { x: '1957' , y: '5.95' },
        { x: '1958' , y: '5.95' },
        { x: '1959' , y: '5.95' },
        { x: '1960' , y: '5.95' },
        { x: '1961' , y: '5.95' },
        { x: '1962' , y: '5.95' },
        { x: '1963' , y: '5.95' },
        { x: '1964' , y: '5.95' },
        { x: '1965' , y: '5.95' },
        { x: '1966' , y: '5.95' },
        { x: '1967' , y: '5.95' },
        { x: '1968' , y: '5.95' },
        { x: '1969' , y: '5.95' },
        { x: '1970' , y: '5.95' },
        { x: '1971' , y: '5.95' },
        { x: '1972' , y: '5.95' },
        { x: '1973' , y: '5.95' },
        { x: '1974' , y: '5.95' },
        { x: '1975' , y: '5.95' },
        { x: '1976' , y: '5.95' },
        { x: '1977' , y: '5.95' },
        { x: '1978' , y: '5.95' },
        { x: '1979' , y: '5.95' },
        { x: '1980' , y: '5.95' },
        { x: '1981' , y: '5.95' },
        { x: '1982' , y: '5.95' },
        { x: '1983' , y: '5.95' },
        { x: '1984' , y: '5.95' },
        { x: '1985' , y: '5.95' },
        { x: '1986' , y: '5.95' },
        { x: '1987' , y: '5.95' },
        { x: '1988' , y: '5.95' },
        { x: '1989' , y: '5.95' },
        { x: '1990' , y: '5.95' },
        { x: '1991' , y: '5.95' },
        { x: '1992' , y: '5.95' },
        { x: '1993' , y: '5.95' },
        { x: '1994' , y: '5.95' },
        { x: '1995' , y: '5.95' },
        { x: '1996' , y: '5.95' },
        { x: '1997' , y: '5.95' },
        { x: '1998' , y: '5.95' },
        { x: '1999' , y: '5.95' },
        { x: '2000' , y: '5.95' },
        { x: '2001' , y: '5.95' },
        { x: '2002' , y: '5.95' },
        { x: '2003' , y: '5.95' },
        { x: '2004' , y: '5.95' },
        { x: '2005' , y: '5.95' },
        { x: '2006' , y: '5.95' },
        { x: '2007' , y: '0.15' },
        { x: '2008' , y: '0.15' },
        { x: '2009' , y: '0.15' },
        { x: '2010' , y: '0.15' },
        { x: '2011' , y: '0.15' },
        { x: '2012' , y: '0.15' },
        { x: '2013' , y: '0.15' },
        { x: '2014' , y: '0.15' },
        { x: '2015' , y: '0.15' },
        { x: '2016' , y: '0.15' },
        { x: '2017' , y: '0.15' },
        { x: '2018' , y: '0.15' },
        { x: '2019' , y: '0.15' },
        { x: '2020' , y: '0.15' },
        { x: '2021' , y: '0.15' },
        { x: '2022' , y: '0.15' },
        { x: '2023' , y: '0.15' },
        { x: '2024' , y: '0.15' },
        { x: '2025' , y: '0.15' },
        { x: '2026' , y: '0.15' },
        { x: '2027' , y: '0.15' },
        { x: '2028' , y: '0.15' },
        { x: '2029' , y: '0.15' },
        { x: '2030' , y: '0.15' },
        { x: '2031' , y: '0.15' },
        { x: '2032' , y: '0.15' },
        { x: '2033' , y: '0.15' },
        { x: '2034' , y: '0.15' },
        { x: '2035' , y: '0.15' },
        { x: '2036' , y: '0.15' },
        { x: '2037' , y: '0.15' },
        { x: '2038' , y: '0.15' },
        { x: '2039' , y: '0.15' },
        { x: '2040' , y: '0.15' },
        { x: '2041' , y: '0.15' },
        { x: '2042' , y: '0.15' },
        { x: '2043' , y: '0.15' },
        { x: '2044' , y: '0.15' },
        { x: '2045' , y: '0.15' },
        { x: '2046' , y: '0.15' },
        { x: '2047' , y: '0.15' },
        { x: '2048' , y: '0.15' },
        { x: '2049' , y: '0.15' },
        { x: '2050' , y: '0.15' },
        { x: '2051' , y: '0.15' },
        { x: '2052' , y: '0.15' },
        { x: '2053' , y: '0.15' },
        { x: '2054' , y: '0.15' },
        { x: '2055' , y: '0.15' },
        { x: '2056' , y: '0.15' },
        { x: '2057' , y: '0.15' },
        { x: '2058' , y: '0.15' },
        { x: '2059' , y: '0.15' },
        { x: '2060' , y: '0.15' },
        { x: '2061' , y: '0.15' },
        { x: '2062' , y: '0.15' },
        { x: '2063' , y: '0.15' },
        { x: '2064' , y: '0.15' },
        { x: '2065' , y: '0.15' },
        { x: '2066' , y: '0.15' },
        { x: '2067' , y: '0.15' },
        { x: '2068' , y: '0.15' },
        { x: '2069' , y: '0.15' },
        { x: '2070' , y: '0.15' },
        { x: '2071' , y: '0.15' },
        { x: '2072' , y: '0.15' },
        { x: '2073' , y: '0.15' },
        { x: '2074' , y: '0.15' },
        { x: '2075' , y: '0.15' },
        { x: '2076' , y: '0.15' },
        { x: '2077' , y: '0.15' },
        { x: '2078' , y: '0.15' },
        { x: '2079' , y: '0.15' },
        { x: '2080' , y: '0.15' },
        { x: '2081' , y: '0.15' },
        { x: '2082' , y: '0.15' },
        { x: '2083' , y: '0.15' },
        { x: '2084' , y: '0.15' },
        { x: '2085' , y: '0.15' },
        { x: '2086' , y: '0.15' },
        { x: '2087' , y: '0.15' },
        { x: '2088' , y: '0.15' },
        { x: '2089' , y: '0.15' },
        { x: '2090' , y: '0.15' },
        { x: '2091' , y: '0.15' },
        { x: '2092' , y: '0.15' },
        { x: '2093' , y: '0.15' },
        { x: '2094' , y: '0.15' },
        { x: '2095' , y: '0.15' },
        { x: '2096' , y: '0.14' },
        { x: '2097' , y: '0.14' },
        { x: '2098' , y: '0.14' },
        { x: '2099' , y: '0.14' },
        { x: '2100' , y: '0.14' },
        { x: '2101' , y: '0.14' },
        { x: '2102' , y: '0.14' },
        { x: '2103' , y: '0.14' },
        { x: '2104' , y: '0.14' },
        { x: '2105' , y: '0.14' },
        { x: '2106' , y: '0.14' },
        { x: '2107' , y: '0.14' },
        { x: '2108' , y: '0.14' },
        { x: '2109' , y: '0.14' },
        { x: '2110' , y: '0.14' },
        { x: '2111' , y: '0.14' },
        { x: '2112' , y: '0.14' },
        { x: '2113' , y: '0.14' },
        { x: '2114' , y: '0.14' },
        { x: '2115' , y: '0.14' },
        { x: '2116' , y: '0.14' },
        { x: '2117' , y: '0.14' },
        { x: '2118' , y: '0.14' },
        { x: '2119' , y: '0.14' },
        { x: '2120' , y: '0.14' },
        { x: '2121' , y: '0.14' },
        { x: '2122' , y: '0.14' },
        { x: '2123' , y: '0.14' },
        { x: '2124' , y: '0.14' },
        { x: '2125' , y: '0.14' },
        { x: '2126' , y: '0.14' },
        { x: '2127' , y: '0.14' },
        { x: '2128' , y: '0.14' },
        { x: '2129' , y: '0.14' },
        { x: '2130' , y: '0.14' },
        { x: '2131' , y: '0.14' },
        { x: '2132' , y: '0.14' },
        { x: '2133' , y: '0.14' },
        { x: '2134' , y: '0.14' },
        { x: '2135' , y: '0.14' },
        { x: '2136' , y: '0.14' },
        { x: '2137' , y: '0.14' },
        { x: '2138' , y: '0.14' },
        { x: '2139' , y: '0.14' },
        { x: '2140' , y: '0.14' },
        { x: '2141' , y: '0.14' },
        { x: '2142' , y: '0.14' },
        { x: '2143' , y: '0.14' },
        { x: '2144' , y: '0.14' },
        { x: '2145' , y: '0.14' },
        { x: '2146' , y: '0.14' },
        { x: '2147' , y: '0.14' },
        { x: '2148' , y: '0.14' },
        { x: '2149' , y: '0.14' },
        { x: '2150' , y: '0.14' },
        { x: '2151' , y: '0.14' },
        { x: '2152' , y: '0.14' },
        { x: '2153' , y: '0.14' },
        { x: '2154' , y: '0.14' },
        { x: '2155' , y: '0.14' },
        { x: '2156' , y: '0.14' },
        { x: '2157' , y: '0.14' },
        { x: '2158' , y: '0.14' },
        { x: '2159' , y: '0.14' },
        { x: '2160' , y: '0.14' },
        { x: '2161' , y: '0.14' },
        { x: '2162' , y: '0.14' },
        { x: '2163' , y: '0.14' },
        { x: '2164' , y: '0.14' },
        { x: '2165' , y: '0.14' },
        { x: '2166' , y: '0.14' },
        { x: '2167' , y: '0.14' },
        { x: '2168' , y: '0.14' },
        { x: '2169' , y: '0.14' },
        { x: '2170' , y: '0.14' },
        { x: '2171' , y: '0.14' },
        { x: '2172' , y: '0.14' },
        { x: '2173' , y: '0.14' },
        { x: '2174' , y: '0.14' },
        { x: '2175' , y: '0.14' },
        { x: '2176' , y: '0.14' },
        { x: '2177' , y: '0.14' },
        { x: '2178' , y: '0.14' },
        { x: '2179' , y: '0.14' },
        { x: '2180' , y: '0.14' },
        { x: '2181' , y: '0.14' },
        { x: '2182' , y: '0.14' },
        { x: '2183' , y: '0.14' },
        { x: '2184' , y: '0.14' },
        { x: '2185' , y: '0.14' },
        { x: '2186' , y: '0.14' },
        { x: '2187' , y: '0.14' },
        { x: '2188' , y: '0.14' },
        { x: '2189' , y: '0.14' },
        { x: '2190' , y: '0.14' },
        { x: '2191' , y: '0.14' },
        { x: '2192' , y: '0.14' },
        { x: '2193' , y: '0.14' },
        { x: '2194' , y: '0.14' },
        { x: '2195' , y: '0.14' },
        { x: '2196' , y: '0.14' },
        { x: '2197' , y: '0.14' },
        { x: '2198' , y: '0.14' },
        { x: '2199' , y: '0.14' },
        { x: '2200' , y: '0.14' },
        { x: '2201' , y: '0.14' },
        { x: '2202' , y: '0.14' },
        { x: '2203' , y: '0.14' },
        { x: '2204' , y: '0.14' },
        { x: '2205' , y: '0.14' },
        { x: '2206' , y: '0.14' },
        { x: '2207' , y: '0.14' },
        { x: '2208' , y: '0.14' },
        { x: '2209' , y: '0.14' },
        { x: '2210' , y: '0.14' },
        { x: '2211' , y: '0.14' },
        { x: '2212' , y: '0.14' },
        { x: '2213' , y: '0.14' },
        { x: '2214' , y: '0.14' },
        { x: '2215' , y: '0.14' },
        { x: '2216' , y: '0.14' },
        { x: '2217' , y: '0.14' },
        { x: '2218' , y: '0.14' },
        { x: '2219' , y: '0.14' },
        { x: '2220' , y: '5.96' },
        { x: '2221' , y: '5.96' },
        { x: '2222' , y: '5.96' },
        { x: '2223' , y: '5.96' },
        { x: '2224' , y: '5.96' },
        { x: '2225' , y: '5.96' },
        { x: '2226' , y: '5.96' },
        { x: '2227' , y: '5.96' },
        { x: '2228' , y: '5.96' },
        { x: '2229' , y: '5.96' },
        { x: '2230' , y: '5.96' },
        { x: '2231' , y: '5.96' },
        { x: '2232' , y: '5.96' },
        { x: '2233' , y: '5.96' },
        { x: '2234' , y: '5.96' },
        { x: '2235' , y: '5.96' },
        { x: '2236' , y: '5.96' },
        { x: '2237' , y: '5.96' },
        { x: '2238' , y: '5.96' },
        { x: '2239' , y: '5.96' },
        { x: '2240' , y: '5.96' },
        { x: '2241' , y: '5.96' },
        { x: '2242' , y: '5.96' },
        { x: '2243' , y: '5.96' },
        { x: '2244' , y: '5.96' },
        { x: '2245' , y: '5.96' },
        { x: '2246' , y: '5.96' },
        { x: '2247' , y: '5.96' },
        { x: '2248' , y: '5.96' },
        { x: '2249' , y: '5.96' },
        { x: '2250' , y: '5.96' },
        { x: '2251' , y: '5.96' },
        { x: '2252' , y: '5.96' },
        { x: '2253' , y: '5.96' },
        { x: '2254' , y: '5.96' },
        { x: '2255' , y: '5.96' },
        { x: '2256' , y: '5.96' },
        { x: '2257' , y: '5.96' },
        { x: '2258' , y: '5.96' },
        { x: '2259' , y: '5.96' },
        { x: '2260' , y: '5.96' },
        { x: '2261' , y: '5.96' },
        { x: '2262' , y: '5.96' },
        { x: '2263' , y: '5.96' },
        { x: '2264' , y: '5.96' },
        { x: '2265' , y: '5.96' },
        { x: '2266' , y: '5.96' },
        { x: '2267' , y: '5.96' },
        { x: '2268' , y: '5.96' },
        { x: '2269' , y: '5.96' },
        { x: '2270' , y: '5.96' },
        { x: '2271' , y: '5.96' },
        { x: '2272' , y: '5.96' },
        { x: '2273' , y: '5.96' },
        { x: '2274' , y: '5.96' },
        { x: '2275' , y: '5.96' },
        { x: '2276' , y: '5.96' },
        { x: '2277' , y: '5.96' },
        { x: '2278' , y: '5.96' },
        { x: '2279' , y: '5.96' },
        { x: '2280' , y: '5.96' },
        { x: '2281' , y: '5.96' },
        { x: '2282' , y: '5.96' },
        { x: '2283' , y: '5.96' },
        { x: '2284' , y: '5.96' },
        { x: '2285' , y: '5.96' },
        { x: '2286' , y: '5.96' },
        { x: '2287' , y: '5.96' },
        { x: '2288' , y: '5.96' },
        { x: '2289' , y: '5.96' },
        { x: '2290' , y: '5.96' },
        { x: '2291' , y: '5.96' },
        { x: '2292' , y: '5.96' },
        { x: '2293' , y: '5.96' },
        { x: '2294' , y: '5.96' },
        { x: '2295' , y: '5.96' },
        { x: '2296' , y: '5.96' },
        { x: '2297' , y: '5.96' },
        { x: '2298' , y: '5.96' },
        { x: '2299' , y: '5.96' },
        { x: '2300' , y: '5.96' },
        { x: '2301' , y: '5.96' },
        { x: '2302' , y: '5.96' },
        { x: '2303' , y: '5.96' },
        { x: '2304' , y: '6.03' },
        { x: '2305' , y: '6.03' },
        { x: '2306' , y: '6.03' },
        { x: '2307' , y: '6.03' },
        { x: '2308' , y: '6.03' },
        { x: '2309' , y: '6.03' },
        { x: '2310' , y: '6.03' },
        { x: '2311' , y: '6.03' },
        { x: '2312' , y: '6.03' },
        { x: '2313' , y: '6.03' },
        { x: '2314' , y: '6.03' },
        { x: '2315' , y: '6.03' },
        { x: '2316' , y: '6.03' },
        { x: '2317' , y: '6.03' },
        { x: '2318' , y: '6.03' },
        { x: '2319' , y: '6.03' },
        { x: '2320' , y: '6.03' },
        { x: '2321' , y: '6.03' },
        { x: '2322' , y: '6.03' },
        { x: '2323' , y: '6.03' },
        { x: '2324' , y: '6.03' },
        { x: '2325' , y: '6.03' },
        { x: '2326' , y: '6.03' },
        { x: '2327' , y: '6.03' },
        { x: '2328' , y: '6.03' },
        { x: '2329' , y: '6.03' },
        { x: '2330' , y: '6.03' },
        { x: '2331' , y: '6.03' },
        { x: '2332' , y: '6.03' },
        { x: '2333' , y: '6.03' },
        { x: '2334' , y: '6.03' },
        { x: '2335' , y: '6.03' },
        { x: '2336' , y: '6.03' },
        { x: '2337' , y: '6.03' },
        { x: '2338' , y: '6.03' },
        { x: '2339' , y: '6.03' },
        { x: '2340' , y: '6.03' },
        { x: '2341' , y: '6.03' },
        { x: '2342' , y: '6.03' },
        { x: '2343' , y: '6.03' },
        { x: '2344' , y: '6.03' },
        { x: '2345' , y: '6.03' },
        { x: '2346' , y: '6.03' },
        { x: '2347' , y: '6.03' },
        { x: '2348' , y: '6.03' },
        { x: '2349' , y: '6.03' },
        { x: '2350' , y: '6.03' },
        { x: '2351' , y: '6.03' },
        { x: '2352' , y: '6.03' },
        { x: '2353' , y: '6.03' },
        { x: '2354' , y: '6.03' },
        { x: '2355' , y: '6.03' },
        { x: '2356' , y: '6.03' },
        { x: '2357' , y: '6.03' },
        { x: '2358' , y: '6.03' },
        { x: '2359' , y: '6.03' },
        { x: '2360' , y: '6.03' },
        { x: '2361' , y: '6.03' },
        { x: '2362' , y: '6.03' },
        { x: '2363' , y: '6.03' },
        { x: '2364' , y: '6.03' },
        { x: '2365' , y: '6.03' },
        { x: '2366' , y: '6.03' },
        { x: '2367' , y: '6.03' },
        { x: '2368' , y: '6.03' },
        { x: '2369' , y: '6.03' },
        { x: '2370' , y: '6.03' },
        { x: '2371' , y: '6.03' },
        { x: '2372' , y: '6.03' },
        { x: '2373' , y: '6.03' },
        { x: '2374' , y: '6.03' },
        { x: '2375' , y: '6.03' },
        { x: '2376' , y: '6.03' },
        { x: '2377' , y: '6.03' },
        { x: '2378' , y: '6.03' },
        { x: '2379' , y: '6.03' },
        { x: '2380' , y: '6.03' },
        { x: '2381' , y: '6.03' },
        { x: '2382' , y: '6.03' },
        { x: '2383' , y: '6.03' },
        { x: '2384' , y: '6.03' },
        { x: '2385' , y: '6.03' },
        { x: '2386' , y: '6.03' },
        { x: '2387' , y: '6.03' },
        { x: '2388' , y: '6.03' },
        { x: '2389' , y: '6.03' },
        { x: '2390' , y: '6.03' },
        { x: '2391' , y: '6.03' },
        { x: '2392' , y: '6.03' },
        { x: '2393' , y: '6.03' },
        { x: '2394' , y: '6.03' },
        { x: '2395' , y: '6.03' },
        { x: '2396' , y: '6.03' },
        { x: '2397' , y: '6.03' },
        { x: '2398' , y: '6.03' },
        { x: '2399' , y: '6.03' },
        { x: '2400' , y: '6.03' },
        { x: '2401' , y: '6.03' },
        { x: '2402' , y: '6.03' },
        { x: '2403' , y: '6.03' },
        { x: '2404' , y: '6.03' },
        { x: '2405' , y: '6.03' },
        { x: '2406' , y: '6.03' },
        { x: '2407' , y: '6.03' },
        { x: '2408' , y: '6.03' },
        { x: '2409' , y: '6.03' },
        { x: '2410' , y: '6.03' },
        { x: '2411' , y: '6.03' },
        { x: '2412' , y: '6.03' },
        { x: '2413' , y: '6.03' },
        { x: '2414' , y: '6.03' },
        { x: '2415' , y: '6.03' },
        { x: '2416' , y: '6.03' },
        { x: '2417' , y: '6.03' },
        { x: '2418' , y: '6.03' },
        { x: '2419' , y: '6.03' },
        { x: '2420' , y: '6.03' },
        { x: '2421' , y: '6.03' },
        { x: '2422' , y: '6.03' },
        { x: '2423' , y: '6.03' },
        { x: '2424' , y: '6.03' },
        { x: '2425' , y: '6.03' },
        { x: '2426' , y: '6.03' },
        { x: '2427' , y: '6.03' },
        { x: '2428' , y: '6.03' },
        { x: '2429' , y: '6.03' },
        { x: '2430' , y: '6.03' },
        { x: '2431' , y: '6.03' },
        { x: '2432' , y: '6.03' },
        { x: '2433' , y: '6.03' },
        { x: '2434' , y: '6.03' },
        { x: '2435' , y: '6.03' },
        { x: '2436' , y: '6.03' },
        { x: '2437' , y: '6.03' },
        { x: '2438' , y: '6.03' },
        { x: '2439' , y: '6.03' },
        { x: '2440' , y: '6.03' },
        { x: '2441' , y: '6.03' },
        { x: '2442' , y: '6.03' },
        { x: '2443' , y: '6.03' },
        { x: '2444' , y: '6.03' },
        { x: '2445' , y: '6.03' },
        { x: '2446' , y: '6.03' },
        { x: '2447' , y: '6.03' },
        { x: '2448' , y: '6.03' },
        { x: '2449' , y: '6.03' },
        { x: '2450' , y: '6.03' },
        { x: '2451' , y: '6.03' },
        { x: '2452' , y: '6.03' },
        { x: '2453' , y: '6.03' },
        { x: '2454' , y: '6.03' },
        { x: '2455' , y: '6.03' },
        { x: '2456' , y: '6.03' },
        { x: '2457' , y: '6.03' },
        { x: '2458' , y: '6.03' },
        { x: '2459' , y: '6.03' },
        { x: '2460' , y: '6.03' },
        { x: '2461' , y: '6.03' },
        { x: '2462' , y: '6.03' },
        { x: '2463' , y: '6.03' },
        { x: '2464' , y: '6.03' },
        { x: '2465' , y: '6.03' },
        { x: '2466' , y: '6.03' },
        { x: '2467' , y: '6.03' },
        { x: '2468' , y: '6.03' },
        { x: '2469' , y: '6.03' },
        { x: '2470' , y: '6.03' },
        { x: '2471' , y: '6.03' },
        { x: '2472' , y: '6.03' },
        { x: '2473' , y: '6.03' },
        { x: '2474' , y: '6.03' },
        { x: '2475' , y: '6.03' },
        { x: '2476' , y: '6.03' },
        { x: '2477' , y: '6.03' },
        { x: '2478' , y: '6.03' },
        { x: '2479' , y: '6.03' },
        { x: '2480' , y: '6.02' },
        { x: '2481' , y: '6.02' },
        { x: '2482' , y: '6.02' },
        { x: '2483' , y: '6.02' },
        { x: '2484' , y: '6.02' },
        { x: '2485' , y: '6.02' },
        { x: '2486' , y: '6.02' },
        { x: '2487' , y: '6.02' },
        { x: '2488' , y: '6.02' },
        { x: '2489' , y: '6.02' },
        { x: '2490' , y: '6.02' },
        { x: '2491' , y: '6.02' },
        { x: '2492' , y: '6.02' },
        { x: '2493' , y: '6.02' },
        { x: '2494' , y: '6.02' },
        { x: '2495' , y: '6.02' },
        { x: '2496' , y: '6.02' },
        { x: '2497' , y: '6.02' },
        { x: '2498' , y: '6.02' },
        { x: '2499' , y: '6.02' },
        { x: '2500' , y: '6.02' },
        { x: '2501' , y: '6.02' },
        { x: '2502' , y: '6.02' },
        { x: '2503' , y: '6.02' },
        { x: '2504' , y: '6.02' },
        { x: '2505' , y: '6.02' },
        { x: '2506' , y: '6.02' },
        { x: '2507' , y: '6.02' },
        { x: '2508' , y: '6.02' },
        { x: '2509' , y: '6.02' },
        { x: '2510' , y: '6.02' },
        { x: '2511' , y: '6.02' },
        { x: '2512' , y: '6.02' },
        { x: '2513' , y: '6.02' },
        { x: '2514' , y: '6.02' },
        { x: '2515' , y: '6.02' },
        { x: '2516' , y: '6.02' },
        { x: '2517' , y: '6.02' },
        { x: '2518' , y: '6.02' },
        { x: '2519' , y: '6.02' },
        { x: '2520' , y: '6.02' },
        { x: '2521' , y: '6.02' },
        { x: '2522' , y: '6.02' },
        { x: '2523' , y: '6.02' },
        { x: '2524' , y: '6.02' },
        { x: '2525' , y: '6.02' },
        { x: '2526' , y: '6.02' },
        { x: '2527' , y: '6.02' },
        { x: '2528' , y: '6.02' },
        { x: '2529' , y: '6.02' },
        { x: '2530' , y: '6.02' },
        { x: '2531' , y: '6.02' },
        { x: '2532' , y: '6.02' },
        { x: '2533' , y: '6.02' },
        { x: '2534' , y: '6.02' },
        { x: '2535' , y: '6.02' },
        { x: '2536' , y: '6.02' },
        { x: '2537' , y: '6.02' },
        { x: '2538' , y: '6.02' },
        { x: '2539' , y: '6.02' },
        { x: '2540' , y: '6.02' },
        { x: '2541' , y: '6.02' },
        { x: '2542' , y: '6.02' },
        { x: '2543' , y: '6.02' },
        { x: '2544' , y: '6.02' },
        { x: '2545' , y: '6.02' },
        { x: '2546' , y: '6.02' },
        { x: '2547' , y: '6.02' },
        { x: '2548' , y: '6.02' },
        { x: '2549' , y: '6.02' },
        { x: '2550' , y: '6.02' },
        { x: '2551' , y: '6.02' },
        { x: '2552' , y: '6.02' },
        { x: '2553' , y: '6.02' },
        { x: '2554' , y: '6.02' },
        { x: '2555' , y: '6.02' },
        { x: '2556' , y: '6.02' },
        { x: '2557' , y: '6.02' },
        { x: '2558' , y: '6.02' },
        { x: '2559' , y: '6.02' },
        { x: '2560' , y: '6.02' },
        { x: '2561' , y: '6.02' },
        { x: '2562' , y: '6.02' },
        { x: '2563' , y: '6.02' },
        { x: '2564' , y: '6.02' },
        { x: '2565' , y: '6.02' },
        { x: '2566' , y: '6.02' },
        { x: '2567' , y: '6.02' },
        { x: '2568' , y: '6.02' },
        { x: '2569' , y: '6.02' },
        { x: '2570' , y: '6.02' },
        { x: '2571' , y: '6.02' },
        { x: '2572' , y: '6.02' },
        { x: '2573' , y: '5.94' },
        { x: '2574' , y: '5.94' },
        { x: '2575' , y: '5.94' },
        { x: '2576' , y: '5.94' },
        { x: '2577' , y: '5.94' },
        { x: '2578' , y: '5.94' },
        { x: '2579' , y: '5.94' },
        { x: '2580' , y: '5.94' },
        { x: '2581' , y: '5.94' },
        { x: '2582' , y: '5.94' },
        { x: '2583' , y: '5.94' },
        { x: '2584' , y: '5.94' },
        { x: '2585' , y: '5.94' },
        { x: '2586' , y: '5.94' },
        { x: '2587' , y: '5.94' },
        { x: '2588' , y: '5.94' },
        { x: '2589' , y: '5.94' },
        { x: '2590' , y: '5.94' },
        { x: '2591' , y: '5.94' },
        { x: '2592' , y: '5.94' },
        { x: '2593' , y: '5.94' },
        { x: '2594' , y: '5.94' },
        { x: '2595' , y: '5.94' },
        { x: '2596' , y: '5.94' },
        { x: '2597' , y: '5.94' },
        { x: '2598' , y: '5.94' },
        { x: '2599' , y: '5.94' },
        { x: '2600' , y: '5.94' },
        { x: '2601' , y: '5.94' },
        { x: '2602' , y: '5.94' },
        { x: '2603' , y: '5.94' },
        { x: '2604' , y: '5.94' },
        { x: '2605' , y: '5.94' },
        { x: '2606' , y: '5.94' },
        { x: '2607' , y: '5.94' },
        { x: '2608' , y: '5.94' },
        { x: '2609' , y: '5.94' },
        { x: '2610' , y: '5.94' },
        { x: '2611' , y: '5.94' },
        { x: '2612' , y: '5.94' },
        { x: '2613' , y: '5.94' },
        { x: '2614' , y: '5.94' },
        { x: '2615' , y: '5.94' },
        { x: '2616' , y: '5.94' },
        { x: '2617' , y: '5.94' },
        { x: '2618' , y: '5.94' },
        { x: '2619' , y: '5.94' },
        { x: '2620' , y: '5.94' },
        { x: '2621' , y: '5.94' },
        { x: '2622' , y: '5.94' },
        { x: '2623' , y: '5.94' },
        { x: '2624' , y: '5.94' },
        { x: '2625' , y: '5.94' },
        { x: '2626' , y: '5.94' },
        { x: '2627' , y: '5.94' },
        { x: '2628' , y: '5.94' },
        { x: '2629' , y: '5.94' },
        { x: '2630' , y: '5.94' },
        { x: '2631' , y: '5.94' },
        { x: '2632' , y: '5.94' },
        { x: '2633' , y: '5.94' },
        { x: '2634' , y: '5.94' },
        { x: '2635' , y: '5.94' },
        { x: '2636' , y: '5.94' },
        { x: '2637' , y: '5.94' },
        { x: '2638' , y: '5.94' },
        { x: '2639' , y: '5.94' },
        { x: '2640' , y: '5.94' },
        { x: '2641' , y: '5.94' },
        { x: '2642' , y: '5.94' },
        { x: '2643' , y: '5.94' },
        { x: '2644' , y: '5.94' },
        { x: '2645' , y: '5.94' },
        { x: '2646' , y: '5.94' },
        { x: '2647' , y: '5.94' },
        { x: '2648' , y: '5.94' },
        { x: '2649' , y: '5.94' },
        { x: '2650' , y: '5.94' },
        { x: '2651' , y: '5.94' },
        { x: '2652' , y: '5.94' },
        { x: '2653' , y: '5.94' },
        { x: '2654' , y: '5.94' },
        { x: '2655' , y: '5.94' },
        { x: '2656' , y: '5.94' },
        { x: '2657' , y: '5.94' },
        { x: '2658' , y: '5.94' },
        { x: '2659' , y: '5.94' },
        { x: '2660' , y: '5.94' },
        { x: '2661' , y: '5.94' },
        { x: '2662' , y: '5.94' },
        { x: '2663' , y: '5.94' },
        { x: '2664' , y: '5.94' },
        { x: '2665' , y: '5.94' },
        { x: '2666' , y: '5.94' },
        { x: '2667' , y: '5.94' },
        { x: '2668' , y: '5.94' },
        { x: '2669' , y: '5.94' },
        { x: '2670' , y: '5.94' },
        { x: '2671' , y: '5.94' },
        { x: '2672' , y: '5.94' },
        { x: '2673' , y: '5.94' },
        { x: '2674' , y: '5.94' },
        { x: '2675' , y: '5.94' },
        { x: '2676' , y: '5.94' },
        { x: '2677' , y: '5.94' },
        { x: '2678' , y: '5.94' },
        { x: '2679' , y: '5.94' },
        { x: '2680' , y: '5.94' },
        { x: '2681' , y: '5.94' },
        { x: '2682' , y: '5.94' },
        { x: '2683' , y: '5.94' },
        { x: '2684' , y: '5.94' },
        { x: '2685' , y: '5.94' },
        { x: '2686' , y: '5.94' },
        { x: '2687' , y: '5.94' },
        { x: '2688' , y: '5.94' },
        { x: '2689' , y: '5.94' },
        { x: '2690' , y: '5.94' },
        { x: '2691' , y: '5.94' },
        { x: '2692' , y: '5.94' },
        { x: '2693' , y: '5.94' },
        { x: '2694' , y: '5.94' },
        { x: '2695' , y: '5.94' },
        { x: '2696' , y: '5.94' },
        { x: '2697' , y: '5.94' },
        { x: '2698' , y: '5.94' },
        { x: '2699' , y: '5.94' },
        { x: '2700' , y: '5.94' },
        { x: '2701' , y: '5.94' },
        { x: '2702' , y: '5.94' },
        { x: '2703' , y: '5.94' },
        { x: '2704' , y: '5.94' },
        { x: '2705' , y: '5.94' },
        { x: '2706' , y: '5.94' },
        { x: '2707' , y: '5.94' },
        { x: '2708' , y: '5.94' },
        { x: '2709' , y: '5.94' },
        { x: '2710' , y: '5.94' },
        { x: '2711' , y: '5.94' },
        { x: '2712' , y: '5.94' },
        { x: '2713' , y: '5.94' },
        { x: '2714' , y: '5.94' },
        { x: '2715' , y: '5.94' },
        { x: '2716' , y: '5.94' },
        { x: '2717' , y: '5.94' },
        { x: '2718' , y: '5.94' },
        { x: '2719' , y: '5.94' },
        { x: '2720' , y: '5.94' },
        { x: '2721' , y: '5.94' },
        { x: '2722' , y: '5.94' },
        { x: '2723' , y: '5.94' },
        { x: '2724' , y: '5.94' },
        { x: '2725' , y: '5.94' },
        { x: '2726' , y: '5.94' },
        { x: '2727' , y: '5.94' },
        { x: '2728' , y: '5.94' },
        { x: '2729' , y: '5.94' },
        { x: '2730' , y: '5.94' },
        { x: '2731' , y: '5.94' },
        { x: '2732' , y: '5.94' },
        { x: '2733' , y: '5.94' },
        { x: '2734' , y: '5.94' },
        { x: '2735' , y: '5.94' },
        { x: '2736' , y: '5.94' },
        { x: '2737' , y: '5.94' },
        { x: '2738' , y: '5.94' },
        { x: '2739' , y: '5.94' },
        { x: '2740' , y: '5.94' },
        { x: '2741' , y: '5.94' },
        { x: '2742' , y: '5.94' },
        { x: '2743' , y: '5.94' },
        { x: '2744' , y: '5.94' },
        { x: '2745' , y: '5.94' },
        { x: '2746' , y: '5.94' },
        { x: '2747' , y: '5.94' },
        { x: '2748' , y: '5.94' },
        { x: '2749' , y: '5.94' },
        { x: '2750' , y: '5.94' },
        { x: '2751' , y: '5.94' },
        { x: '2752' , y: '5.94' },
        { x: '2753' , y: '5.94' },
        { x: '2754' , y: '5.94' },
        { x: '2755' , y: '5.94' },
        { x: '2756' , y: '5.94' },
        { x: '2757' , y: '5.94' },
        { x: '2758' , y: '5.94' },
        { x: '2759' , y: '5.94' },
        { x: '2760' , y: '5.94' },
        { x: '2761' , y: '5.94' },
        { x: '2762' , y: '5.94' },
        { x: '2763' , y: '5.94' },
        { x: '2764' , y: '5.94' },
        { x: '2765' , y: '5.94' },
        { x: '2766' , y: '5.94' },
        { x: '2767' , y: '5.94' },
        { x: '2768' , y: '5.94' },
        { x: '2769' , y: '5.94' },
        { x: '2770' , y: '5.94' },
        { x: '2771' , y: '5.94' },
        { x: '2772' , y: '5.94' },
        { x: '2773' , y: '5.94' },
        { x: '2774' , y: '5.94' },
        { x: '2775' , y: '5.94' },
        { x: '2776' , y: '5.94' },
        { x: '2777' , y: '5.94' },
        { x: '2778' , y: '5.94' },
        { x: '2779' , y: '5.94' },
        { x: '2780' , y: '5.94' },
        { x: '2781' , y: '5.94' },
        { x: '2782' , y: '5.94' },
        { x: '2783' , y: '5.94' },
        { x: '2784' , y: '5.94' },
        { x: '2785' , y: '5.94' },
        { x: '2786' , y: '5.94' },
        { x: '2787' , y: '5.94' },
        { x: '2788' , y: '5.94' },
        { x: '2789' , y: '5.94' },
        { x: '2790' , y: '5.94' },
        { x: '2791' , y: '5.94' },
        { x: '2792' , y: '5.94' },
        { x: '2793' , y: '5.94' },
        { x: '2794' , y: '5.94' },
        { x: '2795' , y: '5.94' },
        { x: '2796' , y: '5.94' },
        { x: '2797' , y: '5.94' },
        { x: '2798' , y: '5.94' },
        { x: '2799' , y: '5.94' },
        { x: '2800' , y: '5.94' },
        { x: '2801' , y: '5.94' },
        { x: '2802' , y: '5.94' },
        { x: '2803' , y: '5.94' },
        { x: '2804' , y: '5.94' },
        { x: '2805' , y: '5.94' },
        { x: '2806' , y: '5.94' },
        { x: '2807' , y: '5.94' },
        { x: '2808' , y: '5.94' },
        { x: '2809' , y: '5.94' },
        { x: '2810' , y: '5.94' },
        { x: '2811' , y: '5.94' },
        { x: '2812' , y: '5.94' },
        { x: '2813' , y: '5.94' },
        { x: '2814' , y: '5.94' },
        { x: '2815' , y: '5.94' },
        { x: '2816' , y: '6.10' },
        { x: '2817' , y: '6.10' },
        { x: '2818' , y: '6.10' },
        { x: '2819' , y: '6.10' },
        { x: '2820' , y: '6.10' },
        { x: '2821' , y: '6.10' },
        { x: '2822' , y: '6.10' },
        { x: '2823' , y: '6.10' },
        { x: '2824' , y: '6.10' },
        { x: '2825' , y: '6.10' },
        { x: '2826' , y: '6.10' },
        { x: '2827' , y: '6.10' },
        { x: '2828' , y: '6.10' },
        { x: '2829' , y: '6.10' },
        { x: '2830' , y: '6.10' },
        { x: '2831' , y: '6.10' },
        { x: '2832' , y: '6.10' },
        { x: '2833' , y: '6.10' },
        { x: '2834' , y: '6.10' },
        { x: '2835' , y: '6.10' },
        { x: '2836' , y: '6.10' },
        { x: '2837' , y: '6.10' },
        { x: '2838' , y: '6.10' },
        { x: '2839' , y: '6.10' },
        { x: '2840' , y: '6.10' },
        { x: '2841' , y: '6.10' },
        { x: '2842' , y: '6.10' },
        { x: '2843' , y: '6.10' },
        { x: '2844' , y: '6.10' },
        { x: '2845' , y: '6.10' },
        { x: '2846' , y: '6.10' },
        { x: '2847' , y: '6.10' },
        { x: '2848' , y: '6.10' },
        { x: '2849' , y: '6.10' },
        { x: '2850' , y: '6.10' },
        { x: '2851' , y: '6.10' },
        { x: '2852' , y: '6.10' },
        { x: '2853' , y: '6.10' },
        { x: '2854' , y: '6.10' },
        { x: '2855' , y: '6.10' },
        { x: '2856' , y: '6.10' },
        { x: '2857' , y: '6.10' },
        { x: '2858' , y: '6.10' },
        { x: '2859' , y: '6.09' },
        { x: '2860' , y: '6.09' },
        { x: '2861' , y: '6.09' },
        { x: '2862' , y: '6.09' },
        { x: '2863' , y: '6.09' },
        { x: '2864' , y: '6.09' },
        { x: '2865' , y: '6.09' },
        { x: '2866' , y: '6.09' },
        { x: '2867' , y: '6.09' },
        { x: '2868' , y: '6.09' },
        { x: '2869' , y: '6.09' },
        { x: '2870' , y: '6.09' },
        { x: '2871' , y: '6.09' },
        { x: '2872' , y: '6.09' },
        { x: '2873' , y: '6.09' },
        { x: '2874' , y: '6.09' },
        { x: '2875' , y: '6.09' },
        { x: '2876' , y: '6.09' },
        { x: '2877' , y: '6.09' },
        { x: '2878' , y: '6.09' },
        { x: '2879' , y: '6.09' },
        { x: '2880' , y: '6.09' },
        { x: '2881' , y: '6.09' },
        { x: '2882' , y: '6.09' },
        { x: '2883' , y: '6.09' },
        { x: '2884' , y: '6.09' },
        { x: '2885' , y: '6.09' },
        { x: '2886' , y: '6.09' },
        { x: '2887' , y: '6.09' },
        { x: '2888' , y: '6.09' },
        { x: '2889' , y: '6.09' },
        { x: '2890' , y: '6.09' },
        { x: '2891' , y: '6.09' },
        { x: '2892' , y: '6.09' },
        { x: '2893' , y: '6.09' },
        { x: '2894' , y: '6.09' },
        { x: '2895' , y: '6.09' },
        { x: '2896' , y: '6.09' },
        { x: '2897' , y: '6.09' },
        { x: '2898' , y: '6.09' },
        { x: '2899' , y: '6.09' },
        { x: '2900' , y: '6.09' },
        { x: '2901' , y: '6.09' },
        { x: '2902' , y: '6.09' },
        { x: '2903' , y: '6.09' },
        { x: '2904' , y: '6.09' },
        { x: '2905' , y: '6.09' },
        { x: '2906' , y: '6.09' },
        { x: '2907' , y: '6.09' },
        { x: '2908' , y: '6.09' },
        { x: '2909' , y: '6.09' },
        { x: '2910' , y: '6.09' },
        { x: '2911' , y: '6.09' },
        { x: '2912' , y: '6.09' },
        { x: '2913' , y: '6.09' },
        { x: '2914' , y: '6.09' },
        { x: '2915' , y: '6.09' },
        { x: '2916' , y: '6.09' },
        { x: '2917' , y: '6.09' },
        { x: '2918' , y: '6.09' },
        { x: '2919' , y: '6.09' },
        { x: '2920' , y: '6.09' },
        { x: '2921' , y: '6.09' },
        { x: '2922' , y: '6.09' },
        { x: '2923' , y: '6.09' },
        { x: '2924' , y: '6.09' },
        { x: '2925' , y: '6.09' },
        { x: '2926' , y: '6.09' },
        { x: '2927' , y: '6.09' },
        { x: '2928' , y: '6.09' },
        { x: '2929' , y: '6.09' },
        { x: '2930' , y: '6.09' },
        { x: '2931' , y: '6.09' },
        { x: '2932' , y: '6.09' },
        { x: '2933' , y: '6.09' },
        { x: '2934' , y: '6.09' },
        { x: '2935' , y: '6.09' },
        { x: '2936' , y: '6.09' },
        { x: '2937' , y: '6.09' },
        { x: '2938' , y: '6.09' },
        { x: '2939' , y: '6.09' },
        { x: '2940' , y: '6.09' },
        { x: '2941' , y: '6.09' },
        { x: '2942' , y: '6.09' },
        { x: '2943' , y: '6.09' },
        { x: '2944' , y: '6.09' },
        { x: '2945' , y: '6.09' },
        { x: '2946' , y: '6.09' },
        { x: '2947' , y: '6.09' },
        { x: '2948' , y: '6.09' },
        { x: '2949' , y: '6.09' },
        { x: '2950' , y: '6.08' },
        { x: '2951' , y: '6.08' },
        { x: '2952' , y: '6.08' },
        { x: '2953' , y: '6.08' },
        { x: '2954' , y: '6.08' },
        { x: '2955' , y: '6.08' },
        { x: '2956' , y: '6.08' },
        { x: '2957' , y: '6.08' },
        { x: '2958' , y: '6.08' },
        { x: '2959' , y: '6.08' },
        { x: '2960' , y: '6.08' },
        { x: '2961' , y: '6.08' },
        { x: '2962' , y: '6.08' },
        { x: '2963' , y: '6.08' },
        { x: '2964' , y: '6.08' },
        { x: '2965' , y: '6.08' },
        { x: '2966' , y: '6.08' },
        { x: '2967' , y: '6.08' },
        { x: '2968' , y: '6.08' },
        { x: '2969' , y: '6.08' },
        { x: '2970' , y: '6.08' },
        { x: '2971' , y: '6.08' },
        { x: '2972' , y: '6.08' },
        { x: '2973' , y: '6.08' },
        { x: '2974' , y: '6.08' },
        { x: '2975' , y: '6.08' },
        { x: '2976' , y: '6.08' },
        { x: '2977' , y: '6.08' },
        { x: '2978' , y: '6.08' },
        { x: '2979' , y: '6.08' },
        { x: '2980' , y: '6.08' },
        { x: '2981' , y: '6.08' },
        { x: '2982' , y: '6.08' },
        { x: '2983' , y: '6.08' },
        { x: '2984' , y: '6.08' },
        { x: '2985' , y: '6.08' },
        { x: '2986' , y: '6.08' },
        { x: '2987' , y: '6.08' },
        { x: '2988' , y: '6.08' },
        { x: '2989' , y: '6.08' },
        { x: '2990' , y: '6.08' },
        { x: '2991' , y: '6.08' },
        { x: '2992' , y: '6.08' },
        { x: '2993' , y: '6.08' },
        { x: '2994' , y: '6.08' },
        { x: '2995' , y: '6.08' },
        { x: '2996' , y: '6.08' },
        { x: '2997' , y: '6.08' },
        { x: '2998' , y: '6.08' },
        { x: '2999' , y: '6.08' },
        { x: '3000' , y: '6.08' },
        { x: '3001' , y: '6.08' },
        { x: '3002' , y: '6.08' },
        { x: '3003' , y: '6.08' },
        { x: '3004' , y: '6.08' },
        { x: '3005' , y: '6.08' },
        { x: '3006' , y: '6.08' },
        { x: '3007' , y: '6.08' },
        { x: '3008' , y: '6.08' },
        { x: '3009' , y: '6.08' },
        { x: '3010' , y: '6.08' },
        { x: '3011' , y: '6.08' },
        { x: '3012' , y: '6.08' },
        { x: '3013' , y: '6.08' },
        { x: '3014' , y: '6.08' },
        { x: '3015' , y: '6.08' },
        { x: '3016' , y: '6.08' },
        { x: '3017' , y: '6.08' },
        { x: '3018' , y: '6.08' },
        { x: '3019' , y: '6.08' },
        { x: '3020' , y: '6.08' },
        { x: '3021' , y: '6.08' },
        { x: '3022' , y: '6.08' },
        { x: '3023' , y: '6.08' },
        { x: '3024' , y: '6.08' },
        { x: '3025' , y: '6.08' },
        { x: '3026' , y: '6.08' },
        { x: '3027' , y: '6.08' },
        { x: '3028' , y: '6.08' },
        { x: '3029' , y: '6.08' },
        { x: '3030' , y: '5.99' },
        { x: '3031' , y: '5.99' },
        { x: '3032' , y: '5.99' },
        { x: '3033' , y: '5.99' },
        { x: '3034' , y: '5.99' },
        { x: '3035' , y: '5.99' },
        { x: '3036' , y: '5.99' },
        { x: '3037' , y: '5.99' },
        { x: '3038' , y: '5.99' },
        { x: '3039' , y: '5.99' },
        { x: '3040' , y: '5.99' },
        { x: '3041' , y: '5.99' },
        { x: '3042' , y: '5.99' },
        { x: '3043' , y: '5.99' },
        { x: '3044' , y: '5.99' },
        { x: '3045' , y: '5.99' },
        { x: '3046' , y: '5.99' },
        { x: '3047' , y: '5.99' },
        { x: '3048' , y: '5.99' },
        { x: '3049' , y: '5.99' },
        { x: '3050' , y: '5.99' },
        { x: '3051' , y: '5.99' },
        { x: '3052' , y: '5.99' },
        { x: '3053' , y: '5.99' },
        { x: '3054' , y: '5.99' },
        { x: '3055' , y: '5.99' },
        { x: '3056' , y: '5.99' },
        { x: '3057' , y: '5.99' },
        { x: '3058' , y: '5.99' },
        { x: '3059' , y: '5.99' },
        { x: '3060' , y: '5.99' },
        { x: '3061' , y: '5.99' },
        { x: '3062' , y: '5.99' },
        { x: '3063' , y: '5.99' },
        { x: '3064' , y: '5.99' },
        { x: '3065' , y: '5.99' },
        { x: '3066' , y: '5.99' },
        { x: '3067' , y: '5.99' },
        { x: '3068' , y: '5.99' },
        { x: '3069' , y: '5.99' },
        { x: '3070' , y: '5.99' },
        { x: '3071' , y: '5.99' },
        { x: '3072' , y: '5.99' },
        { x: '3073' , y: '5.99' },
        { x: '3074' , y: '5.99' },
        { x: '3075' , y: '5.99' },
        { x: '3076' , y: '5.99' },
        { x: '3077' , y: '5.99' },
        { x: '3078' , y: '5.99' },
        { x: '3079' , y: '5.99' },
        { x: '3080' , y: '5.99' },
        { x: '3081' , y: '5.99' },
        { x: '3082' , y: '5.99' },
        { x: '3083' , y: '5.99' },
        { x: '3084' , y: '5.99' },
        { x: '3085' , y: '5.99' },
        { x: '3086' , y: '5.99' },
        { x: '3087' , y: '5.99' },
        { x: '3088' , y: '5.99' },
        { x: '3089' , y: '5.99' },
        { x: '3090' , y: '5.99' },
        { x: '3091' , y: '5.99' },
        { x: '3092' , y: '5.99' },
        { x: '3093' , y: '5.99' },
        { x: '3094' , y: '5.99' },
        { x: '3095' , y: '5.99' },
        { x: '3096' , y: '5.99' },
        { x: '3097' , y: '5.99' },
        { x: '3098' , y: '5.99' },
        { x: '3099' , y: '5.99' },
        { x: '3100' , y: '5.99' },
        { x: '3101' , y: '5.99' },
        { x: '3102' , y: '5.99' },
        { x: '3103' , y: '5.99' },
        { x: '3104' , y: '5.99' },
        { x: '3105' , y: '5.99' },
        { x: '3106' , y: '5.99' },
        { x: '3107' , y: '5.99' },
        { x: '3108' , y: '5.99' },
        { x: '3109' , y: '5.99' },
        { x: '3110' , y: '5.99' },
        { x: '3111' , y: '5.99' },
        { x: '3112' , y: '5.99' },
        { x: '3113' , y: '5.99' },
        { x: '3114' , y: '5.99' },
        { x: '3115' , y: '5.99' },
        { x: '3116' , y: '5.99' },
        { x: '3117' , y: '5.99' },
        { x: '3118' , y: '5.99' },
        { x: '3119' , y: '5.99' },
        { x: '3120' , y: '5.99' },
        { x: '3121' , y: '5.99' },
        { x: '3122' , y: '5.99' },
        { x: '3123' , y: '5.99' },
        { x: '3124' , y: '5.99' },
        { x: '3125' , y: '5.99' },
        { x: '3126' , y: '5.99' },
        { x: '3127' , y: '5.99' },
        { x: '3128' , y: '5.99' },
        { x: '3129' , y: '5.99' },
        { x: '3130' , y: '5.99' },
        { x: '3131' , y: '5.99' },
        { x: '3132' , y: '5.99' },
        { x: '3133' , y: '5.99' },
        { x: '3134' , y: '5.99' },
        { x: '3135' , y: '5.99' },
        { x: '3136' , y: '5.99' },
        { x: '3137' , y: '5.99' },
        { x: '3138' , y: '5.99' },
        { x: '3139' , y: '5.99' },
        { x: '3140' , y: '5.99' },
        { x: '3141' , y: '5.99' },
        { x: '3142' , y: '5.99' },
        { x: '3143' , y: '5.99' },
        { x: '3144' , y: '5.99' },
        { x: '3145' , y: '5.99' },
        { x: '3146' , y: '5.99' },
        { x: '3147' , y: '5.99' },
        { x: '3148' , y: '5.99' },
        { x: '3149' , y: '5.99' },
        { x: '3150' , y: '5.99' },
        { x: '3151' , y: '5.99' },
        { x: '3152' , y: '5.99' },
        { x: '3153' , y: '5.99' },
        { x: '3154' , y: '5.99' },
        { x: '3155' , y: '5.99' },
        { x: '3156' , y: '5.99' },
        { x: '3157' , y: '5.99' },
        { x: '3158' , y: '5.99' },
        { x: '3159' , y: '5.99' },
        { x: '3160' , y: '5.99' },
        { x: '3161' , y: '5.99' },
        { x: '3162' , y: '5.99' },
        { x: '3163' , y: '5.99' },
        { x: '3164' , y: '5.99' },
        { x: '3165' , y: '5.99' },
        { x: '3166' , y: '5.99' },
        { x: '3167' , y: '5.99' },
        { x: '3168' , y: '5.99' },
        { x: '3169' , y: '5.99' },
        { x: '3170' , y: '5.99' },
        { x: '3171' , y: '5.99' },
        { x: '3172' , y: '5.99' },
        { x: '3173' , y: '5.99' },
        { x: '3174' , y: '5.99' },
        { x: '3175' , y: '5.99' },
        { x: '3176' , y: '5.99' },
        { x: '3177' , y: '5.99' },
        { x: '3178' , y: '5.99' },
        { x: '3179' , y: '5.99' },
        { x: '3180' , y: '5.99' },
        { x: '3181' , y: '5.99' },
        { x: '3182' , y: '5.99' },
        { x: '3183' , y: '5.99' },
        { x: '3184' , y: '5.99' },
        { x: '3185' , y: '5.99' },
        { x: '3186' , y: '5.99' },
        { x: '3187' , y: '5.99' },
        { x: '3188' , y: '5.99' },
        { x: '3189' , y: '5.99' },
        { x: '3190' , y: '5.99' },
        { x: '3191' , y: '5.99' },
        { x: '3192' , y: '5.99' },
        { x: '3193' , y: '5.99' },
        { x: '3194' , y: '5.99' },
        { x: '3195' , y: '5.99' },
        { x: '3196' , y: '5.99' },
        { x: '3197' , y: '5.99' },
        { x: '3198' , y: '5.99' },
        { x: '3199' , y: '5.99' },
        { x: '3200' , y: '5.99' },
        { x: '3201' , y: '5.99' },
        { x: '3202' , y: '5.99' },
        { x: '3203' , y: '5.99' },
        { x: '3204' , y: '5.99' },
        { x: '3205' , y: '5.99' },
        { x: '3206' , y: '5.99' },
        { x: '3207' , y: '5.99' },
        { x: '3208' , y: '5.99' },
        { x: '3209' , y: '5.99' },
        { x: '3210' , y: '5.99' },
        { x: '3211' , y: '5.99' },
        { x: '3212' , y: '5.99' },
        { x: '3213' , y: '6.04' },
        { x: '3214' , y: '6.04' },
        { x: '3215' , y: '6.04' },
        { x: '3216' , y: '6.04' },
        { x: '3217' , y: '6.04' },
        { x: '3218' , y: '6.04' },
        { x: '3219' , y: '6.04' },
        { x: '3220' , y: '6.04' },
        { x: '3221' , y: '6.04' },
        { x: '3222' , y: '6.04' },
        { x: '3223' , y: '6.04' },
        { x: '3224' , y: '6.04' },
        { x: '3225' , y: '6.04' },
        { x: '3226' , y: '6.04' },
        { x: '3227' , y: '6.04' },
        { x: '3228' , y: '6.04' },
        { x: '3229' , y: '6.04' },
        { x: '3230' , y: '6.04' },
        { x: '3231' , y: '6.04' },
        { x: '3232' , y: '6.04' },
        { x: '3233' , y: '6.04' },
        { x: '3234' , y: '6.04' },
        { x: '3235' , y: '6.04' },
        { x: '3236' , y: '6.04' },
        { x: '3237' , y: '6.04' },
        { x: '3238' , y: '6.04' },
        { x: '3239' , y: '6.04' },
        { x: '3240' , y: '6.04' },
        { x: '3241' , y: '6.04' },
        { x: '3242' , y: '6.04' },
        { x: '3243' , y: '6.04' },
        { x: '3244' , y: '6.04' },
        { x: '3245' , y: '6.04' },
        { x: '3246' , y: '6.04' },
        { x: '3247' , y: '6.04' },
        { x: '3248' , y: '6.04' },
        { x: '3249' , y: '6.04' },
        { x: '3250' , y: '6.04' },
        { x: '3251' , y: '6.04' },
        { x: '3252' , y: '6.04' },
        { x: '3253' , y: '6.04' },
        { x: '3254' , y: '6.04' },
        { x: '3255' , y: '6.04' },
        { x: '3256' , y: '6.04' },
        { x: '3257' , y: '6.04' },
        { x: '3258' , y: '6.04' },
        { x: '3259' , y: '6.04' },
        { x: '3260' , y: '6.04' },
        { x: '3261' , y: '6.04' },
        { x: '3262' , y: '6.04' },
        { x: '3263' , y: '6.04' },
        { x: '3264' , y: '6.04' },
        { x: '3265' , y: '6.04' },
        { x: '3266' , y: '6.04' },
        { x: '3267' , y: '6.04' },
        { x: '3268' , y: '6.04' },
        { x: '3269' , y: '6.04' },
        { x: '3270' , y: '6.04' },
        { x: '3271' , y: '6.04' },
        { x: '3272' , y: '6.04' },
        { x: '3273' , y: '6.04' },
        { x: '3274' , y: '6.04' },
        { x: '3275' , y: '6.04' },
        { x: '3276' , y: '6.04' },
        { x: '3277' , y: '6.04' },
        { x: '3278' , y: '6.04' },
        { x: '3279' , y: '6.04' },
        { x: '3280' , y: '6.04' },
        { x: '3281' , y: '6.04' },
        { x: '3282' , y: '6.04' },
        { x: '3283' , y: '6.04' },
        { x: '3284' , y: '6.04' },
        { x: '3285' , y: '6.04' },
        { x: '3286' , y: '6.04' },
        { x: '3287' , y: '6.04' },
        { x: '3288' , y: '6.04' },
        { x: '3289' , y: '6.04' },
        { x: '3290' , y: '6.04' },
        { x: '3291' , y: '6.04' },
        { x: '3292' , y: '6.04' },
        { x: '3293' , y: '6.04' },
        { x: '3294' , y: '6.04' },
        { x: '3295' , y: '6.04' },
        { x: '3296' , y: '6.04' },
        { x: '3297' , y: '6.04' },
        { x: '3298' , y: '6.04' },
        { x: '3299' , y: '6.04' },
        { x: '3300' , y: '6.04' },
        { x: '3301' , y: '6.04' },
        { x: '3302' , y: '6.04' },
        { x: '3303' , y: '6.04' },
        { x: '3304' , y: '6.04' },
        { x: '3305' , y: '6.04' },
        { x: '3306' , y: '6.04' },
        { x: '3307' , y: '6.04' },
        { x: '3308' , y: '6.04' },
        { x: '3309' , y: '6.04' },
        { x: '3310' , y: '6.04' },
        { x: '3311' , y: '6.04' },
        { x: '3312' , y: '6.04' },
        { x: '3313' , y: '6.04' },
        { x: '3314' , y: '6.04' },
        { x: '3315' , y: '6.04' },
        { x: '3316' , y: '6.04' },
        { x: '3317' , y: '6.04' },
        { x: '3318' , y: '6.04' },
        { x: '3319' , y: '6.04' },
        { x: '3320' , y: '6.04' },
        { x: '3321' , y: '6.04' },
        { x: '3322' , y: '6.04' },
        { x: '3323' , y: '6.04' },
        { x: '3324' , y: '6.04' },
        { x: '3325' , y: '6.04' },
        { x: '3326' , y: '6.04' },
        { x: '3327' , y: '6.04' },
        { x: '3328' , y: '6.04' },
        { x: '3329' , y: '6.04' },
        { x: '3330' , y: '6.04' },
        { x: '3331' , y: '6.04' },
        { x: '3332' , y: '6.04' },
        { x: '3333' , y: '6.04' },
        { x: '3334' , y: '6.04' },
        { x: '3335' , y: '6.04' },
        { x: '3336' , y: '6.04' },
        { x: '3337' , y: '6.04' },
        { x: '3338' , y: '6.04' },
        { x: '3339' , y: '6.04' },
        { x: '3340' , y: '6.04' },
        { x: '3341' , y: '6.04' },
        { x: '3342' , y: '6.04' },
        { x: '3343' , y: '6.04' },
        { x: '3344' , y: '6.04' },
        { x: '3345' , y: '6.04' },
        { x: '3346' , y: '6.04' },
        { x: '3347' , y: '6.04' },
        { x: '3348' , y: '6.04' },
        { x: '3349' , y: '6.04' },
        { x: '3350' , y: '6.04' },
        { x: '3351' , y: '6.04' },
        { x: '3352' , y: '6.04' },
        { x: '3353' , y: '6.04' },
        { x: '3354' , y: '6.04' },
        { x: '3355' , y: '6.04' },
        { x: '3356' , y: '6.04' },
        { x: '3357' , y: '6.04' },
        { x: '3358' , y: '6.04' },
        { x: '3359' , y: '6.04' },
        { x: '3360' , y: '6.04' },
        { x: '3361' , y: '6.04' },
        { x: '3362' , y: '6.04' },
        { x: '3363' , y: '6.04' },
        { x: '3364' , y: '6.04' },
        { x: '3365' , y: '6.04' },
        { x: '3366' , y: '6.04' },
        { x: '3367' , y: '6.04' },
        { x: '3368' , y: '6.04' },
        { x: '3369' , y: '6.04' },
        { x: '3370' , y: '6.04' },
        { x: '3371' , y: '6.04' },
        { x: '3372' , y: '6.04' },
        { x: '3373' , y: '6.04' },
        { x: '3374' , y: '6.04' },
        { x: '3375' , y: '6.04' },
        { x: '3376' , y: '6.04' },
        { x: '3377' , y: '6.04' },
        { x: '3378' , y: '6.04' },
        { x: '3379' , y: '6.04' },
        { x: '3380' , y: '6.04' },
        { x: '3381' , y: '6.04' },
        { x: '3382' , y: '6.04' },
        { x: '3383' , y: '6.04' },
        { x: '3384' , y: '6.04' },
        { x: '3385' , y: '6.04' },
        { x: '3386' , y: '6.04' },
        { x: '3387' , y: '6.04' },
        { x: '3388' , y: '6.04' },
        { x: '3389' , y: '6.04' },
        { x: '3390' , y: '6.04' },
        { x: '3391' , y: '6.04' },
        { x: '3392' , y: '6.04' },
        { x: '3393' , y: '6.04' },
        { x: '3394' , y: '6.04' },
        { x: '3395' , y: '6.04' },
        { x: '3396' , y: '6.04' },
        { x: '3397' , y: '6.04' },
        { x: '3398' , y: '6.04' },
        { x: '3399' , y: '6.04' },
        { x: '3400' , y: '6.04' },
        { x: '3401' , y: '6.04' },
        { x: '3402' , y: '6.04' },
        { x: '3403' , y: '6.04' },
        { x: '3404' , y: '6.04' },
        { x: '3405' , y: '6.04' },
        { x: '3406' , y: '6.04' },
        { x: '3407' , y: '6.04' },
        { x: '3408' , y: '6.04' },
        { x: '3409' , y: '6.04' },
        { x: '3410' , y: '6.04' },
        { x: '3411' , y: '6.04' },
        { x: '3412' , y: '6.04' },
        { x: '3413' , y: '6.04' },
        { x: '3414' , y: '6.04' },
        { x: '3415' , y: '6.04' },
        { x: '3416' , y: '5.07' },
        { x: '3417' , y: '5.07' },
        { x: '3418' , y: '5.07' },
        { x: '3419' , y: '5.07' },
        { x: '3420' , y: '5.07' },
        { x: '3421' , y: '5.97' },
        { x: '3422' , y: '5.97' },
        { x: '3423' , y: '5.97' },
        { x: '3424' , y: '5.97' },
        { x: '3425' , y: '5.97' },
        { x: '3426' , y: '5.97' },
        { x: '3427' , y: '5.97' },
        { x: '3428' , y: '5.97' },
        { x: '3429' , y: '5.97' },
        { x: '3430' , y: '5.97' },
        { x: '3431' , y: '5.97' },
        { x: '3432' , y: '5.97' },
        { x: '3433' , y: '5.97' },
        { x: '3434' , y: '5.97' },
        { x: '3435' , y: '5.97' },
        { x: '3436' , y: '5.97' },
        { x: '3437' , y: '5.97' },
        { x: '3438' , y: '5.97' },
        { x: '3439' , y: '5.97' },
        { x: '3440' , y: '5.97' },
        { x: '3441' , y: '5.97' },
        { x: '3442' , y: '5.97' },
        { x: '3443' , y: '5.97' },
        { x: '3444' , y: '5.97' },
        { x: '3445' , y: '5.97' },
        { x: '3446' , y: '5.97' },
        { x: '3447' , y: '5.97' },
        { x: '3448' , y: '5.97' },
        { x: '3449' , y: '5.97' },
        { x: '3450' , y: '5.97' },
        { x: '3451' , y: '5.97' },
        { x: '3452' , y: '5.97' },
        { x: '3453' , y: '5.97' },
        { x: '3454' , y: '5.97' },
        { x: '3455' , y: '5.97' },
        { x: '3456' , y: '5.97' },
        { x: '3457' , y: '5.97' },
        { x: '3458' , y: '5.97' },
        { x: '3459' , y: '5.97' },
        { x: '3460' , y: '5.97' },
        { x: '3461' , y: '5.97' },
        { x: '3462' , y: '5.97' },
        { x: '3463' , y: '5.97' },
        { x: '3464' , y: '5.97' },
        { x: '3465' , y: '5.97' },
        { x: '3466' , y: '5.97' },
        { x: '3467' , y: '5.97' },
        { x: '3468' , y: '5.97' },
        { x: '3469' , y: '5.97' },
        { x: '3470' , y: '5.97' },
        { x: '3471' , y: '5.97' },
        { x: '3472' , y: '5.97' },
        { x: '3473' , y: '5.97' },
        { x: '3474' , y: '5.97' },
        { x: '3475' , y: '5.97' },
        { x: '3476' , y: '5.97' },
        { x: '3477' , y: '5.97' },
        { x: '3478' , y: '5.97' },
        { x: '3479' , y: '5.97' },
        { x: '3480' , y: '5.97' },
        { x: '3481' , y: '5.97' },
        { x: '3482' , y: '5.97' },
        { x: '3483' , y: '5.97' },
        { x: '3484' , y: '5.97' },
        { x: '3485' , y: '5.97' },
        { x: '3486' , y: '5.97' },
        { x: '3487' , y: '5.97' },
        { x: '3488' , y: '5.97' },
        { x: '3489' , y: '5.97' },
        { x: '3490' , y: '5.97' },
        { x: '3491' , y: '5.97' },
        { x: '3492' , y: '5.97' },
        { x: '3493' , y: '5.97' },
        { x: '3494' , y: '5.97' },
        { x: '3495' , y: '5.97' },
        { x: '3496' , y: '5.97' },
        { x: '3497' , y: '5.97' },
        { x: '3498' , y: '5.97' },
        { x: '3499' , y: '5.97' },
        { x: '3500' , y: '5.97' },
        { x: '3501' , y: '5.97' },
        { x: '3502' , y: '5.97' },
        { x: '3503' , y: '5.97' },
        { x: '3504' , y: '5.97' },
        { x: '3505' , y: '5.97' },
        { x: '3506' , y: '5.97' },
        { x: '3507' , y: '5.97' },
        { x: '3508' , y: '5.97' },
        { x: '3509' , y: '5.97' },
        { x: '3510' , y: '5.97' },
        { x: '3511' , y: '5.97' },
        { x: '3512' , y: '5.97' },
        { x: '3513' , y: '5.97' },
        { x: '3514' , y: '5.97' },
        { x: '3515' , y: '5.97' },
        { x: '3516' , y: '5.97' },
        { x: '3517' , y: '5.97' },
        { x: '3518' , y: '5.97' },
        { x: '3519' , y: '5.97' },
        { x: '3520' , y: '5.97' },
        { x: '3521' , y: '5.97' },
        { x: '3522' , y: '5.97' },
        { x: '3523' , y: '5.97' },
        { x: '3524' , y: '5.97' },
        { x: '3525' , y: '5.97' },
        { x: '3526' , y: '5.97' },
        { x: '3527' , y: '5.97' },
        { x: '3528' , y: '5.97' },
        { x: '3529' , y: '5.97' },
        { x: '3530' , y: '5.97' },
        { x: '3531' , y: '5.97' },
        { x: '3532' , y: '5.97' },
        { x: '3533' , y: '5.97' },
        { x: '3534' , y: '5.97' },
        { x: '3535' , y: '5.97' },
        { x: '3536' , y: '5.97' },
        { x: '3537' , y: '5.97' },
        { x: '3538' , y: '5.97' },
        { x: '3539' , y: '5.97' },
        { x: '3540' , y: '5.97' },
        { x: '3541' , y: '5.97' },
        { x: '3542' , y: '5.97' },
        { x: '3543' , y: '5.97' },
        { x: '3544' , y: '5.97' },
        { x: '3545' , y: '5.97' },
        { x: '3546' , y: '5.97' },
        { x: '3547' , y: '5.97' },
        { x: '3548' , y: '5.97' },
        { x: '3549' , y: '5.97' },
        { x: '3550' , y: '5.97' },
        { x: '3551' , y: '5.97' },
        { x: '3552' , y: '5.97' },
        { x: '3553' , y: '5.97' },
        { x: '3554' , y: '5.97' },
        { x: '3555' , y: '5.97' },
        { x: '3556' , y: '5.97' },
        { x: '3557' , y: '5.97' },
        { x: '3558' , y: '5.97' },
        { x: '3559' , y: '5.97' },
        { x: '3560' , y: '5.97' },
        { x: '3561' , y: '5.97' },
        { x: '3562' , y: '5.97' },
        { x: '3563' , y: '5.97' },
        { x: '3564' , y: '5.97' },
        { x: '3565' , y: '5.97' },
        { x: '3566' , y: '5.97' },
        { x: '3567' , y: '5.97' },
        { x: '3568' , y: '5.97' },
        { x: '3569' , y: '5.97' },
        { x: '3570' , y: '5.97' },
        { x: '3571' , y: '5.97' },
        { x: '3572' , y: '5.97' },
        { x: '3573' , y: '5.97' },
        { x: '3574' , y: '5.97' },
        { x: '3575' , y: '5.97' },
        { x: '3576' , y: '5.97' },
        { x: '3577' , y: '5.97' },
        { x: '3578' , y: '5.97' },
        { x: '3579' , y: '5.97' },
        { x: '3580' , y: '5.97' },
        { x: '3581' , y: '5.97' },
        { x: '3582' , y: '5.97' },
        { x: '3583' , y: '5.97' },
        { x: '3584' , y: '5.97' },
        { x: '3585' , y: '5.97' },
        { x: '3586' , y: '5.97' },
        { x: '3587' , y: '5.97' },
        { x: '3588' , y: '5.97' },
        { x: '3589' , y: '5.97' },
        { x: '3590' , y: '5.97' },
        { x: '3591' , y: '5.97' },
        { x: '3592' , y: '5.97' },
        { x: '3593' , y: '5.97' },
        { x: '3594' , y: '5.97' },
        { x: '3595' , y: '5.97' },
        { x: '3596' , y: '5.97' },
        { x: '3597' , y: '5.97' },
        { x: '3598' , y: '5.97' },
        { x: '3599' , y: '5.97' },
        { x: '3600' , y: '5.97' },
        { x: '3601' , y: '5.97' },
        { x: '3602' , y: '5.97' },
        { x: '3603' , y: '5.97' },
        { x: '3604' , y: '5.97' },
        { x: '3605' , y: '5.97' },
        { x: '3606' , y: '5.97' },
        { x: '3607' , y: '5.97' },
        { x: '3608' , y: '5.97' },
        { x: '3609' , y: '5.97' },
        { x: '3610' , y: '5.97' },
        { x: '3611' , y: '5.97' },
        { x: '3612' , y: '5.97' },
        { x: '3613' , y: '5.97' },
        { x: '3614' , y: '5.97' },
        { x: '3615' , y: '5.97' },
        { x: '3616' , y: '5.97' },
        { x: '3617' , y: '5.97' },
        { x: '3618' , y: '5.97' },
        { x: '3619' , y: '5.97' },
        { x: '3620' , y: '5.97' },
        { x: '3621' , y: '5.97' },
        { x: '3622' , y: '5.97' },
        { x: '3623' , y: '5.97' },
        { x: '3624' , y: '5.97' },
        { x: '3625' , y: '5.97' },
        { x: '3626' , y: '5.97' },
        { x: '3627' , y: '5.97' },
        { x: '3628' , y: '5.97' },
        { x: '3629' , y: '5.97' },
        { x: '3630' , y: '5.97' },
        { x: '3631' , y: '6.01' },
        { x: '3632' , y: '6.01' },
        { x: '3633' , y: '6.00' },
        { x: '3634' , y: '6.00' },
        { x: '3635' , y: '6.00' },
        { x: '3636' , y: '6.00' },
        { x: '3637' , y: '6.00' },
        { x: '3638' , y: '6.00' },
        { x: '3639' , y: '6.00' },
        { x: '3640' , y: '6.00' },
        { x: '3641' , y: '6.00' },
        { x: '3642' , y: '6.00' },
        { x: '3643' , y: '6.00' },
        { x: '3644' , y: '6.00' },
        { x: '3645' , y: '6.00' },
        { x: '3646' , y: '6.00' },
        { x: '3647' , y: '6.00' },
        { x: '3648' , y: '6.00' },
        { x: '3649' , y: '6.00' },
        { x: '3650' , y: '6.09' },
        { x: '3651' , y: '6.09' },
        { x: '3652' , y: '6.09' },
        { x: '3653' , y: '6.09' },
        { x: '3654' , y: '6.09' },
        { x: '3655' , y: '6.09' },
        { x: '3656' , y: '6.09' },
        { x: '3657' , y: '6.09' },
        { x: '3658' , y: '6.09' },
        { x: '3659' , y: '6.09' },
        { x: '3660' , y: '6.09' },
        { x: '3661' , y: '6.09' },
        { x: '3662' , y: '6.09' },
        { x: '3663' , y: '6.09' },
        { x: '3664' , y: '6.09' },
        { x: '3665' , y: '6.08' },
        { x: '3666' , y: '6.08' },
        { x: '3667' , y: '6.08' },
        { x: '3668' , y: '6.08' },
        { x: '3669' , y: '6.08' },
        { x: '3670' , y: '6.08' },
        { x: '3671' , y: '6.08' },
        { x: '3672' , y: '6.08' },
        { x: '3673' , y: '6.08' },
        { x: '3674' , y: '6.08' },
        { x: '3675' , y: '6.08' },
        { x: '3676' , y: '6.08' },
        { x: '3677' , y: '6.08' },
        { x: '3678' , y: '6.08' },
        { x: '3679' , y: '6.08' },
        { x: '3680' , y: '6.07' },
        { x: '3681' , y: '6.07' },
        { x: '3682' , y: '6.07' },
        { x: '3683' , y: '6.07' },
        { x: '3684' , y: '6.07' },
        { x: '3685' , y: '6.07' },
        { x: '3686' , y: '6.07' },
        { x: '3687' , y: '6.07' },
        { x: '3688' , y: '6.07' },
        { x: '3689' , y: '6.07' },
        { x: '3690' , y: '6.07' },
        { x: '3691' , y: '6.07' },
        { x: '3692' , y: '6.07' },
        { x: '3693' , y: '6.07' },
        { x: '3694' , y: '6.06' },
        { x: '3695' , y: '6.06' },
        { x: '3696' , y: '6.06' },
        { x: '3697' , y: '6.06' },
        { x: '3698' , y: '6.06' },
        { x: '3699' , y: '6.06' },
        { x: '3700' , y: '6.06' },
        { x: '3701' , y: '6.06' },
        { x: '3702' , y: '6.06' },
        { x: '3703' , y: '6.06' },
        { x: '3704' , y: '6.06' },
        { x: '3705' , y: '6.06' },
        { x: '3706' , y: '6.06' },
        { x: '3707' , y: '6.05' },
        { x: '3708' , y: '6.05' },
        { x: '3709' , y: '6.05' },
        { x: '3710' , y: '6.05' },
        { x: '3711' , y: '6.05' },
        { x: '3712' , y: '6.05' },
        { x: '3713' , y: '6.05' },
        { x: '3714' , y: '6.05' },
        { x: '3715' , y: '6.05' },
        { x: '3716' , y: '6.05' },
        { x: '3717' , y: '6.05' },
        { x: '3718' , y: '6.05' },
        { x: '3719' , y: '6.04' },
        { x: '3720' , y: '6.04' },
        { x: '3721' , y: '6.04' },
        { x: '3722' , y: '6.04' },
        { x: '3723' , y: '6.04' },
        { x: '3724' , y: '6.04' },
        { x: '3725' , y: '6.04' },
        { x: '3726' , y: '6.04' },
        { x: '3727' , y: '6.04' },
        { x: '3728' , y: '6.04' },
        { x: '3729' , y: '6.04' },
        { x: '3730' , y: '6.03' },
        { x: '3731' , y: '6.03' },
        { x: '3732' , y: '6.03' },
        { x: '3733' , y: '6.03' },
        { x: '3734' , y: '6.03' },
        { x: '3735' , y: '6.03' },
        { x: '3736' , y: '6.03' },
        { x: '3737' , y: '6.03' },
        { x: '3738' , y: '6.03' },
        { x: '3739' , y: '6.03' },
        { x: '3740' , y: '6.03' },
        { x: '3741' , y: '5.92' },
        { x: '3742' , y: '5.92' },
        { x: '3743' , y: '5.92' },
        { x: '3744' , y: '5.92' },
        { x: '3745' , y: '5.92' },
        { x: '3746' , y: '5.92' },
        { x: '3747' , y: '5.92' },
        { x: '3748' , y: '5.92' },
        { x: '3749' , y: '5.92' },
        { x: '3750' , y: '5.92' },
        { x: '3751' , y: '5.91' },
        { x: '3752' , y: '5.91' },
        { x: '3753' , y: '5.91' },
        { x: '3754' , y: '5.91' },
        { x: '3755' , y: '5.91' },
        { x: '3756' , y: '5.91' },
        { x: '3757' , y: '5.91' },
        { x: '3758' , y: '5.91' },
        { x: '3759' , y: '5.91' },
        { x: '3760' , y: '5.91' },
        { x: '3761' , y: '5.90' },
        { x: '3762' , y: '5.90' },
        { x: '3763' , y: '5.90' },
        { x: '3764' , y: '5.90' },
        { x: '3765' , y: '5.90' },
        { x: '3766' , y: '5.90' },
        { x: '3767' , y: '5.90' },
        { x: '3768' , y: '5.90' },
        { x: '3769' , y: '5.90' },
        { x: '3770' , y: '5.99' },
        { x: '3771' , y: '5.99' },
        { x: '3772' , y: '5.99' },
        { x: '3773' , y: '5.99' },
        { x: '3774' , y: '5.99' },
        { x: '3775' , y: '5.99' },
        { x: '3776' , y: '5.99' },
        { x: '3777' , y: '5.99' },
        { x: '3778' , y: '5.98' },
        { x: '3779' , y: '5.98' },
        { x: '3780' , y: '5.98' },
        { x: '3781' , y: '5.98' },
        { x: '3782' , y: '5.98' },
        { x: '3783' , y: '5.98' },
        { x: '3784' , y: '5.98' },
        { x: '3785' , y: '5.98' },
        { x: '3786' , y: '5.97' },
        { x: '3787' , y: '5.97' },
        { x: '3788' , y: '5.97' },
        { x: '3789' , y: '5.97' },
        { x: '3790' , y: '5.97' },
        { x: '3791' , y: '5.97' },
        { x: '3792' , y: '5.97' },
        { x: '3793' , y: '5.97' },
        { x: '3794' , y: '5.96' },
        { x: '3795' , y: '5.96' },
        { x: '3796' , y: '5.96' },
        { x: '3797' , y: '5.96' },
        { x: '3798' , y: '5.96' },
        { x: '3799' , y: '5.96' },
        { x: '3800' , y: '5.96' },
        { x: '3801' , y: '5.96' },
        { x: '3802' , y: '5.95' },
        { x: '3803' , y: '5.95' },
        { x: '3804' , y: '5.95' },
        { x: '3805' , y: '5.95' },
        { x: '3806' , y: '5.95' },
        { x: '3807' , y: '5.95' },
        { x: '3808' , y: '5.94' },
        { x: '3809' , y: '5.94' },
        { x: '3810' , y: '5.94' },
        { x: '3811' , y: '5.94' },
        { x: '3812' , y: '5.94' },
        { x: '3813' , y: '5.94' },
        { x: '3814' , y: '5.94' },
        { x: '3815' , y: '5.93' },
        { x: '3816' , y: '5.93' },
        { x: '3817' , y: '5.93' },
        { x: '3818' , y: '5.93' },
        { x: '3819' , y: '5.93' },
        { x: '3820' , y: '5.93' },
        { x: '3821' , y: '5.93' },
        { x: '3822' , y: '5.92' },
        { x: '3823' , y: '5.92' },
        { x: '3824' , y: '5.92' },
        { x: '3825' , y: '5.92' },
        { x: '3826' , y: '5.92' },
        { x: '3827' , y: '6.01' },
        { x: '3828' , y: '6.01' },
        { x: '3829' , y: '6.01' },
        { x: '3830' , y: '6.01' },
        { x: '3831' , y: '6.01' },
        { x: '3832' , y: '6.01' },
        { x: '3833' , y: '6.00' },
        { x: '3834' , y: '6.00' },
        { x: '3835' , y: '6.00' },
        { x: '3836' , y: '6.00' },
        { x: '3837' , y: '6.00' },
        { x: '3838' , y: '6.00' },
        { x: '3839' , y: '6.09' },
        { x: '3840' , y: '6.09' },
        { x: '3841' , y: '6.09' },
        { x: '3842' , y: '6.09' },
        { x: '3843' , y: '6.09' },
        { x: '3844' , y: '6.08' },
        { x: '3845' , y: '6.08' },
        { x: '3846' , y: '6.08' },
        { x: '3847' , y: '6.08' },
        { x: '3848' , y: '6.08' },
        { x: '3849' , y: '6.07' },
        { x: '3850' , y: '6.07' },
        { x: '3851' , y: '6.07' },
        { x: '3852' , y: '6.07' },
        { x: '3853' , y: '6.07' },
        { x: '3854' , y: '6.06' },
        { x: '3855' , y: '6.06' },
        { x: '3856' , y: '6.06' },
        { x: '3857' , y: '6.06' },
        { x: '3858' , y: '6.06' },
        { x: '3859' , y: '6.05' },
        { x: '3860' , y: '6.05' },
        { x: '3861' , y: '6.05' },
        { x: '3862' , y: '6.05' },
        { x: '3863' , y: '6.05' },
        { x: '3864' , y: '6.04' },
        { x: '3865' , y: '6.04' },
        { x: '3866' , y: '6.04' },
        { x: '3867' , y: '6.04' },
        { x: '3868' , y: '6.03' },
        { x: '3869' , y: '6.03' },
        { x: '3870' , y: '6.03' },
        { x: '3871' , y: '6.03' },
        { x: '3872' , y: '6.02' },
        { x: '3873' , y: '6.02' },
        { x: '3874' , y: '6.02' },
        { x: '3875' , y: '6.02' },
        { x: '3876' , y: '6.01' },
        { x: '3877' , y: '6.01' },
        { x: '3878' , y: '6.01' },
        { x: '3879' , y: '6.01' },
        { x: '3880' , y: '6.00' },
        { x: '3881' , y: '6.00' },
        { x: '3882' , y: '6.00' },
        { x: '3883' , y: '6.00' },
        { x: '3884' , y: '6.09' },
        { x: '3885' , y: '6.09' },
        { x: '3886' , y: '6.09' },
        { x: '3887' , y: '6.09' },
        { x: '3888' , y: '6.08' },
        { x: '3889' , y: '6.08' },
        { x: '3890' , y: '6.08' },
        { x: '3891' , y: '6.07' },
        { x: '3892' , y: '6.07' },
        { x: '3893' , y: '6.07' },
        { x: '3894' , y: '6.07' },
        { x: '3895' , y: '6.06' },
        { x: '3896' , y: '6.06' },
        { x: '3897' , y: '6.06' },
        { x: '3898' , y: '6.05' },
        { x: '3899' , y: '6.05' },
        { x: '3900' , y: '6.05' },
        { x: '3901' , y: '6.04' },
        { x: '3902' , y: '6.04' },
        { x: '3903' , y: '6.04' },
        { x: '3904' , y: '6.03' },
        { x: '3905' , y: '6.03' },
        { x: '3906' , y: '6.03' },
        { x: '3907' , y: '6.02' },
        { x: '3908' , y: '6.02' },
        { x: '3909' , y: '6.02' },
        { x: '3910' , y: '6.01' },
        { x: '3911' , y: '6.01' },
        { x: '3912' , y: '6.01' },
        { x: '3913' , y: '6.00' },
        { x: '3914' , y: '6.00' },
        { x: '3915' , y: '6.00' },
        { x: '3916' , y: '6.09' },
        { x: '3917' , y: '6.09' },
        { x: '3918' , y: '6.09' },
        { x: '3919' , y: '6.08' },
        { x: '3920' , y: '6.08' },
        { x: '3921' , y: '6.08' },
        { x: '3922' , y: '6.07' },
        { x: '3923' , y: '6.07' },
        { x: '3924' , y: '6.06' },
        { x: '3925' , y: '6.06' },
        { x: '3926' , y: '6.06' },
        { x: '3927' , y: '6.05' },
        { x: '3928' , y: '6.05' },
        { x: '3929' , y: '6.04' },
        { x: '3930' , y: '6.04' },
        { x: '3931' , y: '6.04' },
        { x: '3932' , y: '6.03' },
        { x: '3933' , y: '6.03' },
        { x: '3934' , y: '6.02' },
        { x: '3935' , y: '6.02' },
        { x: '3936' , y: '6.01' },
        { x: '3937' , y: '6.01' },
        { x: '3938' , y: '6.00' },
        { x: '3939' , y: '6.00' },
        { x: '3940' , y: '6.00' },
        { x: '3941' , y: '6.09' },
        { x: '3942' , y: '6.09' },
        { x: '3943' , y: '6.08' },
        { x: '3944' , y: '6.08' },
        { x: '3945' , y: '6.07' },
        { x: '3946' , y: '6.07' },
        { x: '3947' , y: '6.06' },
        { x: '3948' , y: '6.06' },
        { x: '3949' , y: '6.05' },
        { x: '3950' , y: '6.05' },
        { x: '3951' , y: '6.04' },
        { x: '3952' , y: '6.04' },
        { x: '3953' , y: '6.03' },
        { x: '3954' , y: '6.03' },
        { x: '3955' , y: '6.02' },
        { x: '3956' , y: '6.02' },
        { x: '3957' , y: '6.01' },
        { x: '3958' , y: '6.01' },
        { x: '3959' , y: '6.00' },
        { x: '3960' , y: '6.00' },
        { x: '3961' , y: '6.09' },
        { x: '3962' , y: '6.09' },
        { x: '3963' , y: '6.08' },
        { x: '3964' , y: '6.08' },
        { x: '3965' , y: '6.07' },
        { x: '3966' , y: '6.07' },
        { x: '3967' , y: '6.06' },
        { x: '3968' , y: '6.06' },
        { x: '3969' , y: '6.05' },
        { x: '3970' , y: '6.05' },
        { x: '3971' , y: '6.04' },
        { x: '3972' , y: '6.03' },
        { x: '3973' , y: '6.03' },
        { x: '3974' , y: '6.02' },
        { x: '3975' , y: '6.02' },
        { x: '3976' , y: '6.01' },
        { x: '3977' , y: '6.01' },
        { x: '3978' , y: '6.00' },
        { x: '3979' , y: '6.00' },
        { x: '3980' , y: '6.09' },
        { x: '3981' , y: '6.09' },
        { x: '3982' , y: '6.08' },
        { x: '3983' , y: '6.07' },
        { x: '3984' , y: '6.07' },
        { x: '3985' , y: '6.06' },
        { x: '3986' , y: '6.06' },
        { x: '3987' , y: '6.05' },
        { x: '3988' , y: '6.03' },
        { x: '3989' , y: '6.04' },
        { x: '3990' , y: '6.05' },
        { x: '3991' , y: '6.06' },
        { x: '3992' , y: '6.08' },
        { x: '3993' , y: '6.09' },
        { x: '3994' , y: '6.09' },
        { x: '3995' , y: '6.00' },
        { x: '3996' , y: '6.01' },
        { x: '3997' , y: '6.02' },
        { x: '3998' , y: '6.03' },
        { x: '3999' , y: '6.04' },
        { x: '4000' , y: '6.05' },
        { x: '4001' , y: '6.06' },
        { x: '4002' , y: '6.07' },
        { x: '4003' , y: '6.08' },
        { x: '4004' , y: '6.09' },
        { x: '4005' , y: '6.00' },
        { x: '4006' , y: '0.01' },
        { x: '4007' , y: '0.02' },
        { x: '4008' , y: '0.03' },
        { x: '4009' , y: '0.04' },
        { x: '4010' , y: '0.05' },
        { x: '4011' , y: '0.06' },
        { x: '4012' , y: '0.07' },
        { x: '4013' , y: '0.08' },
        { x: '4014' , y: '0.09' },
        { x: '4015' , y: '0.00' },
        { x: '4016' , y: '0.00' },
        { x: '4017' , y: '0.01' },
        { x: '4018' , y: '0.02' },
        { x: '4019' , y: '0.03' },
        { x: '4020' , y: '0.04' },
        { x: '4021' , y: '0.04' },
        { x: '4022' , y: '0.05' },
        { x: '4023' , y: '0.06' },
        { x: '4024' , y: '0.06' },
        { x: '4025' , y: '0.07' },
        { x: '4026' , y: '0.08' },
        { x: '4027' , y: '0.08' },
        { x: '4028' , y: '0.09' },
        { x: '4029' , y: '0.09' },
        { x: '4030' , y: '0.00' },
        { x: '4031' , y: '0.00' },
        { x: '4032' , y: '0.01' },
        { x: '4033' , y: '0.01' },
        { x: '4034' , y: '0.02' },
        { x: '4035' , y: '0.02' },
        { x: '4036' , y: '0.03' },
        { x: '4037' , y: '0.03' },
        { x: '4038' , y: '0.04' },
        { x: '4039' , y: '0.04' },
        { x: '4040' , y: '0.04' },
        { x: '4041' , y: '0.05' },
        { x: '4042' , y: '0.05' },
        { x: '4043' , y: '0.05' },
        { x: '4044' , y: '0.06' },
        { x: '4045' , y: '0.06' },
        { x: '4046' , y: '0.06' },
        { x: '4047' , y: '0.07' },
        { x: '4048' , y: '0.07' },
        { x: '4049' , y: '0.07' },
        { x: '4050' , y: '0.07' },
        { x: '4051' , y: '0.08' },
        { x: '4052' , y: '0.08' }
    ];

    export default Vue.extend({
        name: 'ChartCorrente',
        data: function() {
        return {
            theme2: theme,
            primaryXAxis2: {
            title: 'Tempo [segundo]',
            /*valueType: 'DateTime',*/
            /*skeleton: 'hms',*/
            edgeLabelPlacement: 'Shift',
            majorGridLines: { width: 0 }
        },
        //Initializing Primary Y Axis
        primaryYAxis2:  {
            title: 'Corrente Bateria',
            rangePadding: 'None',
            lineStyle: { width: 0 },
            majorTickLines: { width: 0 }
        },
        legend2:  {
            visible: false
        },
        animation2: { enable: true },
        zoomSettings2:  {
            mode: 'X',
            enableMouseWheelZooming: true,
            enablePinchZooming: true,
            enableSelectionZooming: true,
            enableScrollbar: true
        },
        chartArea2:  {
            border: {
                width: 0
            }
        },

        width2: Browser.isDevice ? '100%' : '80%',
        border: { width: 0.5, color: '#ffd618' },
        title2: 'CORRENTE BATERIA',
        series2: seriesCorrente,
        marker: {
            visible: true, width: 10, height: 10
        },
            tooltip: {enable: true},
        };

        },
        provide: {
            chart: [AreaSeries, /*DateTime*/ Legend, Zoom, ScrollBar, Tooltip]
        },
        methods: {
        
        }   
    });
  </script>

  <style>
    #gradient-chart stop {
		stop-color: #008fac;
	}
	#gradient-chart stop[offset="0"] {
		stop-opacity: 0.75;
	}
	#gradient-chart stop[offset="1"] {
		stop-opacity: 0;
	}
	#control-container {
		padding: 0px !important;
	}
    #chart2_ChartBorder {
        fill: #292929;
    }
    #chart2_ChartTitle {
        fill: #eee;
    }
    #chart2_AxisTitle_1 {
        fill: #eee;
    }
    #chart2_AxisTitle_0 {
        fill: #eee;
    }
    #chart2AxisLabels0 text {
        fill: #eee;
    }
    #chart2AxisLabels1 text {
        fill: #eee;
    }

  </style>